import {
    PENALTY_EXCEPTIONS_STATUSES,
    PENALTY_EXCEPTIONS_TYPES
} from "../../employer/clock_time/constants/ct-timesheet-penalty-exceptions.constants.js";
import {CLOCKS_VIOLATIONS} from "../../../../hmodules/shared-clock-time/constants/shared-actual-clock-time.constants.js";
import {
    BREAK_ATTESTATION_REASONS,
    BREAK_CATEGORIES,
    BREAK_STATUSES,
    BREAK_PENALTY_TYPES,
    BREAK_TIME_STATUSES,
    BREAKS_MEAL_ORDER
} from "../../../../hmodules/team-live/breaks-management/constants/actual-breaks.constants.js";

import {
    TRONC_POTS,
} from '../../../../hmodules/tips-distribution/constants/tips-distribution-shared.constants.js';
import { 
    ENTRY_ACTIONS, 
    ENTRY_ATTRIBUTES 
} from "../../../../hmodules/team-live/breaks-management/constants/breaks-history.constants.js";

(function (app) {
    app.factory('CTTimesheetService', [
        "$filter",
        "TeamScheduleService",
        "hUser",
        "TLEmployerSettingsDataService",
        "ShiftTemplateUtils",
        "TimesheetSettingsService",
        "fairSchedulingService",
        "TSUsersService",
        "jobTitlesDataService",
        "brandServices",
        "userPermissions",
        "useTipsDistributionSharedFactory",
        "useBreaksHistoryFactory",
        function (
            $filter,
            TeamScheduleService,
            hUser,
            TLEmployerSettingsDataService,
            ShiftTemplateUtils,
            TimesheetSettingsService,
            fairSchedulingService,
            TSUsersService,
            jobTitlesDataService,
            brandServices,
            userPermissions,
            useTipsDistributionSharedFactory,
            useBreaksHistoryFactory,
        ) {

        const tipsDistributionSharedFactory = useTipsDistributionSharedFactory();
        const breaksHistoryFactory = useBreaksHistoryFactory();
        var CTTimesheetService = {};
        CTTimesheetService.data = {};
        CTTimesheetService.offeredShifts = [];

        var distributed = {total: 0, value: 0};
        var activeBrand = {};
        var activeBrandUsers = {};
        var paysheetStatusesPerType = {};
        var weekPaysheetTypesInfo = {};
        var clockRightToRestAudit = {};

        var differentialPayLockUps = [];

        let incentiveExtraPayRules = {};

        var currency;
        var isSickLeaveEnabled = false;
        var isBlockOverlappingTimeCardsEnabled = false;
        var timeSheetAdjusmentsSettings = {};
        var timesheetOfflineConflictsSettings = {};
        var editTimeCardReasons = [];
        var canManageHourlyWagesAccess;
        var isPunchPhotosAllowed = false;
        var clockViolationsList = [];
        var timesheetWeeksDetails = {};
        var brandEmployeeLatenessReasons = {};
        var missedBreakAction;
        var brandComplianceStatus;

        var EMPLOYEE_TAGS = [
            {code: 'SHARED_EMPLOYEES', name: 'Secondary'},
            {code: 'HOME_EMPLOYEES', name: 'Primary'}
        ];

        const DAY_IN_SECONDS = 24 * 60 * 60;

        const CLOCKS_VIOLATIONS_MAP = {
            [CLOCKS_VIOLATIONS.OVERTIME]: {code: CLOCKS_VIOLATIONS.OVERTIME, name: $filter('translate')('Overtime')},
            [CLOCKS_VIOLATIONS.BREAKS_PREMIUMS]: {code: CLOCKS_VIOLATIONS.BREAKS_PREMIUMS, name: $filter('translate')('Break premiums manager applied')},
            [CLOCKS_VIOLATIONS.SPREAD_OF_HOURS]: {code: CLOCKS_VIOLATIONS.SPREAD_OF_HOURS, name: $filter('translate')('Spread of Hours')},
            [CLOCKS_VIOLATIONS.REPORTING_TIME]: {code: CLOCKS_VIOLATIONS.REPORTING_TIME, name: $filter('translate')('Reporting Time')},
            [CLOCKS_VIOLATIONS.SPLIT_SHIFT]: {code: CLOCKS_VIOLATIONS.SPLIT_SHIFT, name: $filter('translate')('Split-Shift')},
            [CLOCKS_VIOLATIONS.FWW]: {code: CLOCKS_VIOLATIONS.FWW, name: $filter('translate')('Fair Workweek')},
            [CLOCKS_VIOLATIONS.RTR]: {code: CLOCKS_VIOLATIONS.RTR, name: $filter('translate')('Right to Rest')},
            [CLOCKS_VIOLATIONS.PHOTO_ISSUES]: {code: CLOCKS_VIOLATIONS.PHOTO_ISSUES, name: $filter('translate')('Photos to check')},
            [CLOCKS_VIOLATIONS.PH_REST_DAY]: {code: CLOCKS_VIOLATIONS.PH_REST_DAY, name: $filter('translate')('Rest day')},
            [CLOCKS_VIOLATIONS.EMPLOYER_IGNORE]: {code: CLOCKS_VIOLATIONS.EMPLOYER_IGNORE, name: $filter('translate')('Break premiums manager dismissed')},
            [CLOCKS_VIOLATIONS.EMPLOYEE_IGNORED]: {code: CLOCKS_VIOLATIONS.EMPLOYEE_IGNORED, name: $filter('translate')('Employee waived break')},
            [CLOCKS_VIOLATIONS.BREAKS_PREMIUMS_IGNORED_BY_WAIVER_ON_FILE]: {code: CLOCKS_VIOLATIONS.BREAKS_PREMIUMS_IGNORED_BY_WAIVER_ON_FILE, name: $filter('translate')('Breaks premiums ignored due to waiver on file')},
        };

        var viewEmployeeWagePermissions = {
            HOURLY: userPermissions.PERMISSIONS.VIEW_HOURLY_EMPLOYEES_WAGES,
            SALARIED: userPermissions.PERMISSIONS.VIEW_SALARIED_EMPLOYEES_WAGES,
            WEIGHTED_SHIFT: userPermissions.PERMISSIONS.VIEW_WEIGHTED_SHIFT_EMPLOYEES_WAGES,
        };

        CTTimesheetService.EMPLOYEE_STATUSES_ACK = {};
        CTTimesheetService.EMPLOYEE_STATUSES_ACK.PENDING_EMPLOYEE_APPROVAL = 'PENDING_EMPLOYEE_APPROVAL';
        CTTimesheetService.EMPLOYEE_STATUSES_ACK.EMPLOYEE_PROTESTED = 'EMPLOYEE_PROTESTED';
        CTTimesheetService.EMPLOYEE_STATUSES_ACK.EMPLOYEE_APPROVED = 'EMPLOYEE_APPROVED';
        CTTimesheetService.EMPLOYEE_STATUSES_ACK.EMPLOYER_APPROVED = 'EMPLOYER_APPROVED';
        CTTimesheetService.EMPLOYEE_STATUSES_ACK.EMPLOYEE_ACKNOWLEDGED = 'EMPLOYEE_ACKNOWLEDGED';
        CTTimesheetService.CLOCK_TIME_STATUS_PERSONAL_REASON_MODES = {
            PERSONAL : 'PERSONAL',
            PERSONAL_MUTUALLY_AGREED :'PERSONAL_MUTUALLY_AGREED'
        };

        CTTimesheetService.shiftTemplates = {};

        CTTimesheetService.getEmployeesTagsList = function (isMinorSchedulingEnabled) {
            if (isMinorSchedulingEnabled) {
                return EMPLOYEE_TAGS.concat([
                    {code: 'MINORS_EMPLOYEES', name: 'Minors'},
                    {code: 'ADULTS_EMPLOYEES', name: 'Adults'}
                ]);
            }

            return EMPLOYEE_TAGS;
        };


            CTTimesheetService.prepareTimesheetLockStatus = function (weekData, lockStatuses) {
            var weekLockStatus = {};

            if (weekData['time_status'] !== 'FUTURE') {

                var weekDate = weekData['date'];

                var selectedWeek = lockStatuses.find(function (week) {
                    return week.date === weekDate;
                });

                if (weekData['time_status'] === 'PAST') {
                    weekLockStatus['isLocked'] = (selectedWeek && selectedWeek['status'] === 'LOCKED') || (weekData['pds_status'] === 'CLOSED');
                } else {
                    weekLockStatus['isLocked'] = false;
                }

                if (weekLockStatus.isLocked) {
                    if (weekData && weekData['pds_status']) {
                        weekLockStatus.lockReason = !!selectedWeek && (weekData['pds_status'] !== 'CLOSED') ? 'MANAGER' : 'PDS_CLOSED';
                    } else {
                        weekLockStatus.lockReason = !!selectedWeek ? 'MANAGER' : 'PDS_CLOSED';
                    }
                }
            }
            return weekLockStatus;
        };

            CTTimesheetService.areAllPaysheetsClosed = function (weekPaysheetTypesInfo, activeBrand) {
            if (_.isEmpty(weekPaysheetTypesInfo)) {
                return false;
            }

            var employeePaymentTypes = activeBrand.employee_payment_types || [];
            var paysheetTypes = Object.keys(weekPaysheetTypesInfo) || [];
            var mapPaymentTypesWithPDS = {};

            for (var i = 0; i < employeePaymentTypes.length; i++) {
                var type = employeePaymentTypes[i].type;
                if (paysheetTypes.indexOf(type) === -1) {
                    return false;
                }
                mapPaymentTypesWithPDS[type] = weekPaysheetTypesInfo[type].is_pds_closed;
            }

            return _.every(mapPaymentTypesWithPDS, function(isClosed) {
                return isClosed;
            });
        };

            let extractClocks = (employees) => {
                return employees
                    .flatMap(employee =>
                        employee.days.flatMap(day =>
                            day.clocks
                        )
                    );
            };

            let isThereARunningShift = (clocks) => {
                return clocks.some(clock => clock.actual_clock.is_partial_paid)
            };

            CTTimesheetService.getDifferentialPayLockUps = function () {
            return differentialPayLockUps;
        };

        CTTimesheetService.setDifferentialPayLockUps = function (lookups) {
            differentialPayLockUps =  lookups;
        };

        CTTimesheetService.setIncentiveExtraPayRules = (rules) => {
            incentiveExtraPayRules = rules;
        }

        CTTimesheetService.getIncentiveExtraPayRules = () => {
            return incentiveExtraPayRules;
        }

        CTTimesheetService.setTimesheetWeeksDetails = (weeksToCheck, lockData, employees) => {
            timesheetWeeksDetails = {
                current_week: {
                    date: weeksToCheck[0],
                    lock_status: {}
                },
                next_week: {
                    date: weeksToCheck[1],
                    lock_status: {}
                }
            };
            let clocks = extractClocks(employees);
            timesheetWeeksDetails['current_week']['pds_status'] = (CTTimesheetService.areAllPaysheetsClosed(weekPaysheetTypesInfo, activeBrand) && !isThereARunningShift(clocks)) ? 'CLOSED' : 'OPEN';
            timesheetWeeksDetails['current_week']['time_status'] = CTTimesheetService.getWeekTimeStatus(weeksToCheck[0]);
            timesheetWeeksDetails['next_week']['time_status'] = CTTimesheetService.getWeekTimeStatus(weeksToCheck[1]);
            timesheetWeeksDetails['current_week']['lock_status'] = CTTimesheetService.prepareTimesheetLockStatus(timesheetWeeksDetails['current_week'], lockData);
            timesheetWeeksDetails['next_week']['lock_status'] = CTTimesheetService.prepareTimesheetLockStatus(timesheetWeeksDetails['next_week'], lockData);
        };

        var getSelectedBusinessDayTime = function (startDayOfSelectedWeek, brand, withExtension) {
            var selectedBusinessDay = getSelectedBusinessDay(startDayOfSelectedWeek, brand);
            var dayOpenHour = selectedBusinessDay? selectedBusinessDay.open_time * 1000: 0;
            var dayCloseHour = selectedBusinessDay? selectedBusinessDay.close_time * 1000: 0;

            if (dayCloseHour <= dayOpenHour) {
                dayCloseHour += 24 * 60 * 60 * 1000;
            }
            var endDateOfWeek = moment(startDayOfSelectedWeek).clone().add(6, 'days').format('YYYY-MM-DD');
            var closeTimeWithExtension = dayCloseHour;
            if (withExtension) {
                closeTimeWithExtension += selectedBusinessDay.close_time_extension * 1000;
            }

            return {
                'weekOpenDay': moment(startDayOfSelectedWeek, "YYYY-MM-DD").add(dayOpenHour, 'ms').valueOf(),
                'weekCloseDay': moment(endDateOfWeek, "YYYY-MM-DD").add(closeTimeWithExtension, 'ms').valueOf()
            };
        };

        CTTimesheetService.getWeekTimeStatus = function (startDayOfWeek, brand) {
            brand = brand || activeBrand;
            var selectedBusinessWeek = getSelectedBusinessDayTime(startDayOfWeek, brand, true);
            var currentTimeInBrandTimeZone = moment(moment().tz(brand.timezoneName).format("YYYY-MM-DD HH:mm")).valueOf();

            if (currentTimeInBrandTimeZone >= selectedBusinessWeek['weekOpenDay'] && currentTimeInBrandTimeZone <= selectedBusinessWeek['weekCloseDay']) {
                return 'CURRENT';
            }
            else if (selectedBusinessWeek['weekCloseDay'] > currentTimeInBrandTimeZone) {
                return 'FUTURE';
            }
            else {
                return 'PAST';
            }
        };

        var getSelectedBusinessDay = function (date, brand) {
            var dayDate = moment(date);
            var brandToCheck = brand || activeBrand;

            var brandBusinessDay = {};
            for (var i in brandToCheck.business_day) {
                var businessDay = brandToCheck.business_day[i];
                if (dayDate.isSame(businessDay.start_date, 'day') || dayDate.isAfter(businessDay.start_date, 'day')) {
                    brandBusinessDay = businessDay;
                    break;
                }
            }

            if (_.isEmpty(brandBusinessDay)) {
                brandBusinessDay = brandToCheck.business_day[brandToCheck.business_day.length - 1];
            }
            return brandBusinessDay;
        }

        CTTimesheetService.getTimesheetLockStatuses = function (weekToCheck) {
            if (weekToCheck === 'CURRENT_WEEK') {
                return timesheetWeeksDetails['current_week'] && timesheetWeeksDetails['current_week'].lock_status;
            }
            else if (weekToCheck === 'NEXT_WEEK') {
                return timesheetWeeksDetails['next_week'] && timesheetWeeksDetails['next_week'].lock_status;
            }
        };

        CTTimesheetService.getTimesheetWeekDetails = function (weekToCheck) {
            if (weekToCheck === 'CURRENT_WEEK') {
                return timesheetWeeksDetails['current_week'];
            }
            else if (weekToCheck === 'NEXT_WEEK') {
                return timesheetWeeksDetails['next_week'];
            }
        }

        CTTimesheetService.updateTimesheetLockStatuses = function (weekToCheck, status, reason) {
            var weekLockStatus = {};

            if (weekToCheck === 'CURRENT_WEEK') {
                weekLockStatus = timesheetWeeksDetails['current_week']['lock_status'];
            }
            else if (weekToCheck === 'NEXT_WEEK') {
                weekLockStatus = timesheetWeeksDetails['next_week']['lock_status'];
            }

            weekLockStatus.isLocked = status === 'LOCKED';
            if (weekLockStatus.isLocked) {
                weekLockStatus.lockReason = reason;
            }
        };

        CTTimesheetService.lockTimesheet = function (brandId, selectedWeek) {
            var defer = $q.defer();

            PerformanceAggregatorAPI.lockTimesheet(brandId, selectedWeek)
                .then(function (){
                    defer.resolve('LOCKED');
                })
                .catch(function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        CTTimesheetService.getClockRightToRestAudit = function (brandId, userId, rightToRestId, clockId, shiftId, isScheduled) {
            var defer = $q.defer();
            var id = clockId;

            if (isScheduled) {
                id = shiftId;
            }

            if (!_.isEmpty(clockRightToRestAudit)) {
                defer.resolve(clockRightToRestAudit);
            } else {
                PerformanceAggregatorAPI.getClockRightToRestAudit(brandId, userId, id)
                    .then(function (res) {
                        clockRightToRestAudit = res[0] || {};
                        defer.resolve(clockRightToRestAudit);
                    })
                    .catch(function (error) {
                        defer.reject(error);
                    });
            }

            return defer.promise;

        };

        CTTimesheetService.resetClockRightToRestAudit = function () {
            clockRightToRestAudit = {};
        };

        CTTimesheetService.unlockTimesheet = function (brandId, selectedWeek) {
            var defer = $q.defer();

            PerformanceAggregatorAPI.unlockTimesheet(brandId, selectedWeek)
                .then(function (){
                    defer.resolve('UNLOCKED');
                })
                .catch(function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        CTTimesheetService.setUsersDetails = function (users) {
            activeBrandUsers = users;
        };

        CTTimesheetService.getClockViolations = function () {
            var clockViolations = [];

            for (var i in clockViolationsList) {
                var violationCode = clockViolationsList[i];

                clockViolations.push(CLOCKS_VIOLATIONS_MAP[violationCode]);
            }

            return clockViolations;
        };

        CTTimesheetService.setActiveBrand = function (brand) {
            activeBrand = brand;
            currency = $filter("locationCurrencySymbol")(brand);
        };

        CTTimesheetService.setSickLeaveEnabled = function (isEnabled) {
            isSickLeaveEnabled = isEnabled;
        };

        CTTimesheetService.getSickLeaveEnabled = function () {
            return isSickLeaveEnabled;
        };

        CTTimesheetService.setTimeSheetAdjusmentsSettings = function (settings) {
            timeSheetAdjusmentsSettings = settings;
        };

        CTTimesheetService.getTimeSheetAdjusmentsSettings = function () {
            return timeSheetAdjusmentsSettings;
        };

        CTTimesheetService.setBlockOverlappingTimeCardsEnabled = function (isEnabled) {
            isBlockOverlappingTimeCardsEnabled = isEnabled;
        };

        CTTimesheetService.getBlockOverlappingTimeCardsEnabled = function () {
            return isBlockOverlappingTimeCardsEnabled;
        };

        CTTimesheetService.setTimeSheetOfflineConflictsSettings = function (settings) {
            timesheetOfflineConflictsSettings = settings;
        };

        CTTimesheetService.getTimeSheetOfflineConflictsSettings = function () {
            return timesheetOfflineConflictsSettings;
        };

        CTTimesheetService.isUnresolved = function (penalty) {
            return [PENALTY_EXCEPTIONS_STATUSES.PENDING_APPROVAL].indexOf(penalty.status) > -1;
        };

        CTTimesheetService.refusePenalty = function (penalty) {
            penalty.status = PENALTY_EXCEPTIONS_STATUSES.IGNORED;
        };

        CTTimesheetService.confirmPenalty = function (penalty) {
            penalty.status = PENALTY_EXCEPTIONS_STATUSES.APPROVED;
        };

        CTTimesheetService.showException = (penalty, penaltyType) => {
            return (
                penalty.status === PENALTY_EXCEPTIONS_STATUSES.IGNORED ||
                (
                    penalty.status === PENALTY_EXCEPTIONS_STATUSES.SYSTEM_IGNORED &&
                    penalty.isExceptionListDisabled
                ) ||
                (
                    penalty.status === PENALTY_EXCEPTIONS_STATUSES.SYSTEM_IGNORED &&
                    penaltyType === PENALTY_EXCEPTIONS_TYPES.CALL_IN
                )
            );
        };

        CTTimesheetService.isPenaltyExceptionsListDisable = function (penalty) {
            return penalty.isExceptionListDisabled;
        };


        CTTimesheetService.setEditTimeCardReasons = function (reasons) {
            editTimeCardReasons = reasons;
        };

        CTTimesheetService.getBrandEditTimeCardReasons = function () {
            return editTimeCardReasons;
        };

        CTTimesheetService.setManageWagesPermission = function (hasManageHourlyWagesAccess) {
            canManageHourlyWagesAccess = hasManageHourlyWagesAccess;
        };

        CTTimesheetService.setPunchPhotosPermission = function (allowViewPunchPhotos) {
            isPunchPhotosAllowed = allowViewPunchPhotos;
        };

        CTTimesheetService.setBrandComplianceStatus = function (complianceStatus) {
            brandComplianceStatus = complianceStatus;
        };

        CTTimesheetService.getBrandComplianceStatus = function () {
            return brandComplianceStatus;
        };

        var checkTimeZoneOffsetDifference = function (clockIn, clockOut, timezoneName) {
            var clockInOffset = moment.tz(moment(clockIn.slice(0, -1)).format('YYYY-MM-DD HH:mm'), timezoneName)._offset;
            var clockOutOffset = moment.tz(moment(clockOut.slice(0, -1)).format('YYYY-MM-DD HH:mm'), timezoneName)._offset;

            return clockOutOffset !== clockInOffset;
        };

        var convertSecondsToTime = function (time) {
            var sec_num = parseInt(time, 10);
            var hours = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);
            return {
                hours: hours,
                minutes: minutes,
                seconds: seconds
            };
        };

        CTTimesheetService.getUnresolvedPenaltiesCount = function (clock) {
            var count = 0;
            if (clock.status !== 'DELETED' && clock.actual_clock.penalties && clock.actual_clock.penalties.length) {
                for (var i in clock.actual_clock.penalties) {
                    if (clock.actual_clock.penalties[i].status === "PENDING_APPROVAL") {
                        count++;
                    }
                }
            }

            if (clock.status !== 'DELETED' && clock.actual_clock.right_to_rest && clock.actual_clock.right_to_rest.length) {
                for (var i in clock.actual_clock.right_to_rest) {
                    if (clock.actual_clock.right_to_rest[i].status === "PENDING_APPROVAL") {
                        count++;
                    }
                }
            }
            if (
                clock.status !== 'DELETED' &&
                clock.actual_clock.call_in &&
                clock.actual_clock.call_in.duration > 0 &&
                clock.actual_clock.call_in.status === "PENDING_APPROVAL"
            ) {
                count++;
            }

            return count;
        };

        //for overnight shifts, check if the day and next day periods are closed
        CTTimesheetService.isPaysheetPeriodClosedForNextDay = function (date, clockPayType) {
            var isPaysheetPeriodOpen = true;
            var isNextPaysheetPeriodOpen = true;
            var selectedDate = moment(date);
            var nextDate = selectedDate.clone().add(1, 'days');
            var paysheetTypesInfo = paysheetStatusesPerType[clockPayType];
            if (!paysheetTypesInfo) {
                return false;
            }
            var paysheetStatuses = paysheetTypesInfo['paysheet_statuses'] || [];
            if (!paysheetStatuses.length) {
                return false;
            }

            for (var j in paysheetStatuses) {
                var paysheetStatusInfo = paysheetStatuses[j];
                var paysheetStatusInfoDate = $filter("formatDateIgnoreTimeZone")(paysheetStatusInfo['date'], "YYYY-MM-DD");

                if (moment(paysheetStatusInfoDate).isSame(selectedDate, "days")) {
                    isPaysheetPeriodOpen = paysheetStatusInfo['status'] === 'OPEN';
                }

                if (moment(paysheetStatusInfoDate).isSame(nextDate, "days")) {
                    isNextPaysheetPeriodOpen = paysheetStatusInfo['status'] === 'OPEN';
                }
            }

            return isPaysheetPeriodOpen && !isNextPaysheetPeriodOpen;
        };

        CTTimesheetService.checkOfflineTimesheetConflicts = function (clock, conflicts) {
            var timeSheetOfflineConflictsSettings = CTTimesheetService.getTimeSheetOfflineConflictsSettings();
            var isOfflineModeEnabled = timeSheetOfflineConflictsSettings && timeSheetOfflineConflictsSettings.status === 'ACTIVE';
            var userConflicts = {};

            if (conflicts && conflicts.length) {
                userConflicts = _.findWhere(conflicts, {user_id: clock['employeeId']});
            }

            if (isOfflineModeEnabled && userConflicts && userConflicts['conflicts'] && userConflicts['conflicts'].length) {
                var clockId = clock && clock.actual_clock && clock.actual_clock.id;
                var timesheetOfflineConflictIndex = userConflicts['conflicts'].findIndex(function (conflict) {
                    return clockId === conflict.clock_id;
                });

                return timesheetOfflineConflictIndex > -1;
            } else {
                return false;
            }
        };

        var checkIfClockInOpenPDSPeriod = function (clock) {
            var isPaysheetPeriodOpen = true;
            var isOvernightShiftSettingsEnabled = CTTimesheetService.checkOvernightShiftsSettings(clock.date);
            var isTimesheetLockedDuoToClosedPDS =
                timesheetWeeksDetails['current_week'] &&
                timesheetWeeksDetails['current_week']['lock_status'] &&
                timesheetWeeksDetails['current_week']['lock_status'].isLocked &&
                timesheetWeeksDetails['current_week']['lock_status']['lockReason'] === 'PDS_CLOSED';

            if (_.isEmpty(paysheetStatusesPerType)) {
                return true;
            }
            if (!clock.rate) {
                return true;
            }

            var clockPayType = clock.rate && clock.rate.pay_type;
            if (isOvernightShiftSettingsEnabled) {
                var clockDate = $filter('formatDateIgnoreTimeZone')(clock.date, "YYYY-MM-DD");
                if (clock.isExtendedOverNextDay && CTTimesheetService.isPaysheetPeriodClosedForNextDay(clockDate, clockPayType)) {
                    return false;
                } else if (_.isEmpty(weekPaysheetTypesInfo)) {
                    return true;
                }
            }

            if (isTimesheetLockedDuoToClosedPDS) {
                return false;
            }

            if (!paysheetStatusesPerType[clockPayType]) {
                return true;
            }
            var paysheetStatuses = paysheetStatusesPerType[clockPayType].paysheet_statuses;

            var paysheetStatus = paysheetStatuses.find(function (paysheetStatus) {
                return moment(clock.date).isSame(paysheetStatus.date, 'day');
            });

            if (!paysheetStatus) {
                return true;
            }
            if (clockPayType === 'SALARIED' && paysheetStatusesPerType[clockPayType].allow_paysheet_early_closure) {
                return true;
            }
            for (var j in paysheetStatusesPerType[clockPayType].paysheet_statuses) {
                paysheetStatus = paysheetStatusesPerType[clockPayType].paysheet_statuses[j];

                if (isOvernightShiftSettingsEnabled && clock.isExtendedOverNextDay) {
                    var nextDate = moment(clock.date).add(1, 'days');

                    if (moment(clock.date).isSame(paysheetStatus.date, 'day') || nextDate.isSame(paysheetStatus.date, 'day')) {
                        isPaysheetPeriodOpen = isPaysheetPeriodOpen && paysheetStatus.status === "OPEN";
                    }
                } else {
                    if (moment(clock.date).isSame(paysheetStatus.date, 'day')) {
                        isPaysheetPeriodOpen = paysheetStatus.status === "OPEN";
                        break;
                    }

                }
            }
            return isPaysheetPeriodOpen;
        };

        //This is to determin if the time entry is editable or not

        var findClockEntryEdiability = function (clock) {
            var isClockEditable = false;
            var isOvernightShiftSettingsEnabled = CTTimesheetService.checkOvernightShiftsSettings(clock.date);
            var isTimesheetLocked =
                timesheetWeeksDetails['current_week'] &&
                timesheetWeeksDetails['current_week']['lock_status'] &&
                timesheetWeeksDetails['current_week']['lock_status'].isLocked;
            var isNextWeekTimesheetLocked =
                timesheetWeeksDetails['next_week'] &&
                timesheetWeeksDetails['next_week']['lock_status'] &&
                timesheetWeeksDetails['next_week']['lock_status'].isLocked;

            if (isTimesheetLocked) {
                return false;
            }

            if (clock.status === 'DELETED') {
                return false;
            }
            if (isOvernightShiftSettingsEnabled) {
                var timesheetSelectedWeek = Utils.getWeekStart(moment(clock.date), activeBrand.startDayOfWeek).format('YYYY-MM-DD');
                var startDayOfNextWeek = moment(timesheetSelectedWeek).clone().add(7, 'days').format('YYYY-MM-DD');

                if (
                    clock.isExtendedOverNextDay &&
                    (
                        !isTimesheetLocked &&
                        isNextWeekTimesheetLocked &&
                        moment(clock.actual_clock.clock_out).isSameOrAfter(startDayOfNextWeek)
                    )
                ) {
                    return false;
                }
            }

            if (brandComplianceStatus !== "DONE") {
                return false;
            }

            if (clock.isInOpenPDSPeriod || (!clock.isInOpenPDSPeriod && clock.actual_clock.is_partial_paid)) {
                return true;
            }

            return isClockEditable;
        };

        //Format clock object
        var formatClockObject = function (employee, day, clock, conflicts, attemptInfo, penaltyDetails) {

            clock.date = day.date;
            clock.employeeId = employee.id;

            //Calculate some values
            if (clock.scheduled_shift) {
                clock.scheduled = (new Date(clock.scheduled_shift.clock_out).getTime() - new Date(clock.scheduled_shift.clock_in).getTime()) / 1000;
            }

            if (clock.actual_clock.code) {
                var template = CTTimesheetService.shiftTemplates[clock.actual_clock.code];
                clock.shiftDuration = 0;

                if (template) {
                    for (var j in template.intervals) {
                        var interval = template.intervals[j];

                        if (interval.end_time > interval.start_time) {
                            clock.shiftDuration += parseFloat(((interval.end_time - interval.start_time) / 3600).toFixed(2));
                        }
                        else {
                            clock.shiftDuration += parseFloat((((interval.end_time + (24 * 3600)) - interval.start_time) / 3600).toFixed(2));
                        }
                    }
                }
            }

            if (attemptInfo) {
                clock.actual_clock.lowConfidenceType = (attemptInfo.confidence_type === 'LOW');
            }

            if (CTTimesheetService.offeredShifts.length) {
                var offeredShift = CTTimesheetService.offeredShifts.find(function (shift) {
                    return shift.destination_assignee_shift['id'] == clock.actual_clock['shift_id']
                });
                clock.is_unassigned_shift_with_opted_in_vsl = !!offeredShift;
            }


            clock.currency = currency;
            clock.rate_formatted = (clock.rate && clock.rate.value != null) ? (clock.rate.value / 100).toFixed(2) : "-";
            clock.amount_formatted = clock.amount ? (clock.amount / 100).toFixed(2) : "-";

            if (typeof clock.right_to_rest_amount === 'number' || typeof clock.penalties_amount === 'number') {
                clock.premium_pay = Utils.roundFloat((((clock.penalties_amount || 0) + (clock.right_to_rest_amount || 0))) / 100);
            }

            if (clock.actual_clock && clock.actual_clock.differential_pay && typeof clock.actual_clock.differential_pay.amount === 'number') {
                clock.differentialPayAmount = Utils.roundFloat((clock.actual_clock.differential_pay.amount || 0) / 100);
            }

            if (clock.actual_clock.penalties && clock.actual_clock.penalties.length) {
                clock.actual_clock.penalties.forEach(function (penalty) {
                    if (penaltyDetails && (penalty.id === penaltyDetails.id)) {
                        if (penaltyDetails.ignore_reason) {
                            penalty.ignore_reason = penaltyDetails.ignore_reason;
                        }

                        penalty.status = penaltyDetails.status;
                    }
                });
            }

            clock.isExtendedOverNextDay = false;
            clock.isExtendedFromPreviousDay = false;

            if (clock['actual_clock'] && clock['actual_clock']['is_extended_clock']) {
                if (clock['actual_clock']['is_editable']) {
                    clock.isExtendedOverNextDay = true;
                } else {
                    clock.isExtendedFromPreviousDay = true;
                }
            }
            clock.isInOpenPDSPeriod = checkIfClockInOpenPDSPeriod(clock);
            clock.is_editable = findClockEntryEdiability(clock);
            clock.is_tips_editable = clock.is_editable;
            clock.has_unresolved_penalties = !!CTTimesheetService.getUnresolvedPenaltiesCount(clock);
            clock.has_timesheet_offline_conflict = CTTimesheetService.checkOfflineTimesheetConflicts(clock, conflicts);
            clock.isGreaterThan24Hours = CTTimesheetService.checkIfClockGreaterThan24Hours(clock);

            if (clock.isExtendedFromPreviousDay) {
                clock.is_editable = false;
            }

            //this not a usual value so it needs re-format
            if (typeof(clock.spread_of_hours) !== "undefined") {
                clock.spread_of_hours = clock.spread_of_hours ? 3600 : 0;
            }

            clock.renderingDetails = {
                toggled: false
            };

            clock.is_archived = clock.status === 'DELETED';

            return clock;
        };

        var checkClocksOverlapping = function (firstClockClockIn, firstClockClockOut, secondClockClockIn, secondClockClockOut) {
            if (moment(firstClockClockIn).isBefore(secondClockClockOut) && moment(firstClockClockOut).isAfter(secondClockClockIn)) {
                return true;
            }
        };

        CTTimesheetService.checkClocksOverlapping = function (clocksList, clockId, clockIn, clockOut, employeeId, date) {
            if (!clockIn || !clockOut || !employeeId) {
                return false;
            }

            var overlapping = false;

            for (var i in clocksList) {
                var firstClock = clocksList[i];

                if (firstClock['status'] === 'DELETED' || !firstClock['actual_clock']['clock_in'] || !firstClock['actual_clock']['clock_out']) {
                    continue;
                }

                var extendedDate = new Date(moment(date).add(1, 'days').format('YYYY-MM-DD')).toISOString();

                if (
                    (parseInt(firstClock['employeeId']) === parseInt(employeeId)) &&
                    (moment(firstClock['date']).isSame(date) || (CTTimesheetService.checkOvernightShiftsSettings(date) && moment(firstClock['date']).isSame(extendedDate))) &&
                    (!clockId || (firstClock['actual_clock']['id'] !== clockId))
                ) {

                    overlapping = checkClocksOverlapping(
                        firstClock['actual_clock']['clock_in'],
                        firstClock['actual_clock']['clock_out'],
                        Utils.getISODate(clockIn),
                        Utils.getISODate(clockOut)
                    );

                    if (overlapping) {
                        break;
                    }
                }
            }

            return overlapping;
        };

        CTTimesheetService.checkForOverlappingBreaks = function (breaks) {
            var overlapping = false;

            for (var i = 0; i < breaks.length; i++) {
                var firstBreak = breaks[i];

                if (firstBreak['status'] === 'DELETED' || !firstBreak['start_time'] || !firstBreak['end_time']) {
                    continue;
                }

                for (var j = i + 1; j < breaks.length; j++) {
                    var secondBreak = breaks[j];

                    if (firstBreak.id === secondBreak.id || firstBreak['status'] === 'DELETED' || !firstBreak['start_time'] || !firstBreak['end_time']) {
                        continue;
                    }

                    overlapping = checkClocksOverlapping(
                        firstBreak['start_time'],
                        firstBreak['end_time'],
                        secondBreak['start_time'],
                        secondBreak['end_time']
                    );

                    if (overlapping) {
                        break;
                    }
                }
                if (overlapping) {
                    break;
                }
            }

            return overlapping;
        };

        CTTimesheetService.handleBreaksErrors = function (err, title) {
            if (err.status === 400) {
                var message = $filter("translate")("Something went wrong") + '! ' + $filter("translate")("Please try again");

                if (err.data && err.data.errors && err.data.errors[0]) {
                    switch (err.data.errors[0].code) {
                        case "BREAK_TIME_OUT_OF_CLOCK":
                            message = $filter("translate")("Enter a break time that's before the shift ends") + ".";
                            break;
                        case "OVERLAPPING_BREAKS":
                            message = $filter("translate")("Some breaks are overlapping") + ". " +
                                $filter("translate")("To resolve") + ", " + $filter("translate")("contact support") + ".";
                            break;
                        case "INVALID_BREAK_TIMES":
                        case "INTERLEAVING_BREAK_WITH_CLOCK":
                            message = $filter("translate")("Some breaks are outside the shift duration") + ". " +
                                $filter("translate")("To resolve") + ", " + $filter("translate")("contact support") + ".";
                            break;
                    }
                }

                hAlert({
                    title: title,
                    text: message,
                    custom_class: 'h-general-error-alert',
                });

            } else {
                console.error(err);
            }
        };

        CTTimesheetService.resetOverlappingClocks = function () {
            var clocks = CTTimesheetService.data['clocks'];

            for (var i in clocks) {
                clocks[i]['isOverlappedWithOtherClocks'] = false;
            }
        };

        CTTimesheetService.hasViewEmployeeWagePermissions = function (policyParser, clock) {
            var isViewEmployeeWagePermissionsEnabled;
            var paytype = clock.rate && clock.rate.pay_type;

            if (paytype) {
                var isViewPaytypePermissionsEnabled = policyParser
                    .positions(clock['actual_clock'].position.category.code, clock['actual_clock'].position.code)
                    .has(viewEmployeeWagePermissions[paytype]);
                isViewEmployeeWagePermissionsEnabled = isViewPaytypePermissionsEnabled && clock.rate.value == null;
            } else {
                isViewEmployeeWagePermissionsEnabled = policyParser.hasAny(userPermissions.VIEW_WAGES);
            }

            return isViewEmployeeWagePermissionsEnabled;
        };

        CTTimesheetService.calculateClockStatusesCounts = function (filteredClocks, policyParser, timesheetView) {
            var clocksStatusCount = {
                overlappedClocks: 0,
                unresolvedPenaltiesCount: 0,
                missedBreaksWarnings: 0,
                financialWarnings: 0,
                punchPhotosWarnings: 0
            };

            var timesheetData = CTTimesheetService.getData();

            for (var i in filteredClocks) {
                var firstClock = filteredClocks[i];
                var penaltiesWarnings = CTTimesheetService.getUnresolvedPenaltiesCount(firstClock);
                var clockWarnings = (firstClock['warnings'] && firstClock['warnings'].length) || 0;

                if (firstClock.status !== 'DELETED' && (firstClock.actual_clock.clock_in || firstClock.actual_clock.clock_out)) {
                    clocksStatusCount['missedBreaksWarnings'] += clockWarnings;
                }

                if (firstClock['status'] !== 'DELETED') {
                    firstClock['hasFinancialWarning'] = CTTimesheetService.hasViewEmployeeWagePermissions(policyParser, firstClock);

                    if (firstClock['hasFinancialWarning']) {
                        clocksStatusCount['financialWarnings']++;
                    }
                }

                if (timesheetView !== 'WEEK' || (timesheetView === 'WEEK' && !firstClock.isExtendedFromPreviousDay)) {
                    if (firstClock['status'] === 'APPROVED') {
                        clocksStatusCount['approvedClocks']++;
                    }

                    if (firstClock['actual_clock']['lowConfidenceType'] && !firstClock.isEmployeeRevoked) {
                        clocksStatusCount['punchPhotosWarnings']++;
                    }

                    if (firstClock['status'] === 'PENDING_APPROVAL') {
                        clocksStatusCount['pendingApproveClocks']++;
                    }

                    clocksStatusCount['unresolvedPenaltiesCount'] += penaltiesWarnings;
                }

                if (firstClock['status'] === 'DELETED' || !firstClock['actual_clock']['clock_in'] || !firstClock['actual_clock']['clock_out']) {
                    continue;
                }

                for (var j in filteredClocks) {
                    var secondClock = filteredClocks[j];

                    if (secondClock['status'] === 'DELETED' || !secondClock['actual_clock']['clock_in'] || !secondClock['actual_clock']['clock_out']) {
                        continue;
                    }

                    if (
                        firstClock['employeeId'] === secondClock['employeeId'] &&
                        firstClock['actual_clock']['id'] !== secondClock['actual_clock']['id']
                    ) {
                        var extendedFirstDate = new Date(moment(firstClock['date']).add(1, 'days').format('YYYY-MM-DD')).toISOString();
                        var extendedSecondDate = new Date(moment(secondClock['date']).add(1, 'days').format('YYYY-MM-DD')).toISOString();

                        if (
                            firstClock['date'] === secondClock['date'] ||
                            (
                                CTTimesheetService.checkOvernightShiftsSettings(secondClock['date']) &&
                                (moment(secondClock['date']).isSame(extendedFirstDate) || moment(firstClock['date']).isSame(extendedSecondDate))
                            )
                        ) {
                            firstClock['isOverlappedWithOtherClocks'] = checkClocksOverlapping(
                                firstClock['actual_clock']['clock_in'],
                                firstClock['actual_clock']['clock_out'],
                                secondClock['actual_clock']['clock_in'],
                                secondClock['actual_clock']['clock_out']
                            );

                            if (firstClock['isOverlappedWithOtherClocks']) {
                                clocksStatusCount['overlappedClocks']++;
                                break;
                            }
                        }
                    }
                }
            }

            clocksStatusCount['errorsCount'] = timesheetData['errors'].length;

            return clocksStatusCount;
        };

        /**
         * Normalize data
         * @param data
         * @returns {{clocks: Array, errors: Array}}
         */
        var flattenData = function (data) {
            var result = {
                clocks: [],
                errors: [],
                is_denied_access_to_all_categories: data.is_denied_access_to_all_categories,
                paysheet_types_info: data.paysheet_types_info,
                meal_deduction_status: {},
                error_reasons: data.error_reasons,
                confidence_attempts: data.confidence_attempts? data.confidence_attempts : [],
                penalty_details: data.selected_penalty || {},
                remote_clocks: [],
            };

            for (var day in data.meal_breaks_status) {
                result.meal_deduction_status[new Date(day).toISOString()] = {};
                result.meal_deduction_status[new Date(day).toISOString()].status = data.meal_breaks_status[day] && data.meal_breaks_status[day].status == "ENABLED";
                result.meal_deduction_status[new Date(day).toISOString()].payment_value = (data.meal_breaks_status[day]) ? data.meal_breaks_status[day].payment_value : 0;
            }

            if (data.employees && data.employees.length) {
                data.employees.forEach(function (employee) {
                    employee.days.forEach(function (day) {
                        day.clocks.forEach(function (clock) {
                            var attemptInfo = {};
                            if (result.confidence_attempts) {
                                var attemptsData = _.find(result.confidence_attempts, function (item) {
                                    return moment(item.date).isSame(moment($filter("formatDateIgnoreTimeZone")(day.date, 'YYYY-MM-DD')));
                                });
                                if (attemptsData) {
                                    attemptInfo = _.find(attemptsData['attempts'], function (item) {
                                        return item.clock_id === clock.actual_clock.id;
                                    });
                                    clock.isEmployeeRevoked = attemptInfo && attemptInfo.is_employee_ignored;
                                }
                            }

                            result.clocks.push(formatClockObject(employee, day, angular.copy(clock),data.timesheet_offline_conflicts , attemptInfo, result.penalty_details));
                        });
                    });
                });
            }

            if (data.employees_errors && data.employees_errors.length) {
                data.employees_errors.forEach(function (employee) {
                    employee.days.forEach(function (day) {
                        day.clocks.forEach(function (clock) {
                            result.errors.push(formatClockObject(employee, day, angular.copy(clock), data.timesheet_offline_conflicts));
                        });
                    });
                });
            }

            return result;
        };

        CTTimesheetService.parseData = function (data) {
            return flattenData(data);
        };

        //Formating data
        CTTimesheetService.setData = function (data) {
            CTTimesheetService.data = flattenData(data);
        };

        CTTimesheetService.flattenAndSetRemoteClocksData = (data) => {
            CTTimesheetService.remoteClocksData = [];
            if (data.length) {
                data.forEach((employee) => {
                    employee.days.forEach((day) => {
                        day.clocks.forEach((clock) => {
                            let remoteClock = {...clock};
                            remoteClock.actual_clock = {...clock.clock, actualClockStatus: clock.actual_clock.status};
                            remoteClock.status = remoteClock.actual_clock.status;
                            CTTimesheetService.remoteClocksData.push(formatClockObject(employee, day, remoteClock));
                        });
                    });
                });
            }
        }

        CTTimesheetService.updateRemoteClocksData = (updatedClock) => {
            let clockIndex = CTTimesheetService.remoteClocksData.findIndex(clock => clock.actual_clock.id === updatedClock.actual_clock.id);

            if (clockIndex > -1) {
                CTTimesheetService.remoteClocksData[clockIndex] = {...updatedClock};
            } else {
                CTTimesheetService.remoteClocksData.push({...updatedClock});
            }
        }

        CTTimesheetService.getRemoteClocksData = ()=> {
            return CTTimesheetService.remoteClocksData;
        }

        CTTimesheetService.setUsersOfferedShifts = function (offeredShifts) {
            CTTimesheetService.offeredShifts = offeredShifts;
        };

        //Formating data
        CTTimesheetService.getData = function () {
            return CTTimesheetService.data;
        };

        var isEmployeeTagIncluded = function (employeeId, filterByEmployeeTags) {
            var user = activeBrandUsers[employeeId];

            if (user) {
                var isMinor = user.isMinor();
                var isHomeEmployee = user.is_primary;
                var minorFilterApplied = filterByEmployeeTags.indexOf('MINORS_EMPLOYEES') > -1 && isMinor;
                var adultFilterApplied = filterByEmployeeTags.indexOf('ADULTS_EMPLOYEES') > -1 && !isMinor;
                var sharedFilterApplied = filterByEmployeeTags.indexOf('SHARED_EMPLOYEES') > -1 && !isHomeEmployee;
                var homeFilterApplied = filterByEmployeeTags.indexOf('HOME_EMPLOYEES') > -1 && isHomeEmployee;

                return (minorFilterApplied || adultFilterApplied || sharedFilterApplied || homeFilterApplied);
            }
        };

        const isEmployeeEmploymentTypeIncluded = (employeeId, employmentTypesFilter) => {
            const user = activeBrandUsers[employeeId];
            return employmentTypesFilter.includes(user.employment_type);
        }

        var isClockHasViolations = function (clock, filterByClockViolations) {
            for (var i in filterByClockViolations) {
                var violationCode = filterByClockViolations[i];

                if (violationCode === 'OVERTIME' && (clock.overtime || clock.double_overtime || clock.overtime_shift_weights || (clock.rest_day_pay && clock.rest_day_pay.overtime && clock.rest_day_pay.overtime.seconds))) {
                    return true;
                }

                if (violationCode === CLOCKS_VIOLATIONS_MAP.BREAKS_PREMIUMS.code && clock.earned_hours) {
                    return true;
                }

                if (violationCode === CLOCKS_VIOLATIONS_MAP.EMPLOYEE_IGNORED.code && clock.actual_clock.breaks.some(function (obj) {
                    return obj.status === CLOCKS_VIOLATIONS_MAP.EMPLOYEE_IGNORED.code;
                })) {
                    return true;
                }

                if (violationCode === CLOCKS_VIOLATIONS_MAP.EMPLOYER_IGNORE.code && clock.actual_clock.breaks.some(function (obj) {
                    return obj.status === CLOCKS_VIOLATIONS_MAP.EMPLOYER_IGNORE.code;
                })) {
                    return true;
                }

                if (violationCode === CLOCKS_VIOLATIONS_MAP.BREAKS_PREMIUMS_IGNORED_BY_WAIVER_ON_FILE.code && clock.actual_clock.breaks.some(function (obj) {
                    return ['AUTOMATICALLY_IGNORED_BY_WAIVER_ON_FILE', 'IGNORED_BY_WAIVER_ON_FILE'].indexOf(obj.status) > -1;
                })) {
                    return true;
                }

                if (violationCode === 'SPREAD_OF_HOURS' && clock.spread_of_hours) {
                    return true;
                }

                if (violationCode === 'REPORTING_TIME' && clock.actual_clock.call_in && ["APPROVED", "SYSTEM_APPROVED"].indexOf(clock.actual_clock.call_in.status) > -1 && clock.actual_clock.call_in.duration) {
                    return true;
                }

                if (violationCode === 'SPLIT_SHIFT' && clock.actual_clock.split_shift_penalty && clock.actual_clock.split_shift_penalty.status === 'INCLUDED' && clock.actual_clock.split_shift_penalty.amount) {
                    return true;
                }

                if (violationCode === 'FWW' && clock.penalties_amount) {
                    return true;
                }

                if (violationCode === 'RTR' && clock.right_to_rest_amount) {
                    return true;
                }

                if (violationCode === CLOCKS_VIOLATIONS_MAP.PHOTO_ISSUES.code && clock.actual_clock.lowConfidenceType && !clock.isEmployeeRevoked) {
                    return true;
                }

                if (violationCode === 'PH_REST_DAY' && clock.rest_day_pay && clock.rest_day_pay.net_shift_seconds) {
                    return true;
                }
            }
        };

        CTTimesheetService.getFilteredClocksByType = (type, filtersMap, passedData) => {
            var data = passedData || CTTimesheetService.data;

            let filteredClocks = [];

            if (type === 'errors') {
                filteredClocks = data.errors.filter((error) => {
                    return CTTimesheetService.checkFiltersPerClock(filtersMap, error);
                });
            } else if (type === 'remote') {
                filteredClocks = CTTimesheetService.remoteClocksData?.filter((clock) => {
                    return CTTimesheetService.checkFiltersPerClock(filtersMap, clock);
                });
            }

            return filteredClocks;
        };

        CTTimesheetService.checkFiltersPerClock = (filtersMap, clock) => {
            var categoryId = filtersMap['categoryId'];
            var positionId = filtersMap['positionId'];
            var filterByUsersIds = filtersMap['filterByUsersIds'];
            var filterByLabelIds = filtersMap['filterByLabelIds'];
            filterByUsersIds = filterByUsersIds || [];
            filterByLabelIds = filterByLabelIds || [];
            var timeSheetOfflineConflictsSettings = CTTimesheetService.getTimeSheetOfflineConflictsSettings();
            var isOfflineModeEnabled = timeSheetOfflineConflictsSettings && timeSheetOfflineConflictsSettings.status === 'ACTIVE';

            let result = true;
            let positionCatFlag = true;

            if (positionId && clock.actual_clock.position.code !== positionId) {
                positionCatFlag = false;
            } else if (
                categoryId && clock.actual_clock.position.category.code !== categoryId
            ) {
                positionCatFlag = false;
            }

            if (filterByUsersIds.length && filterByUsersIds.indexOf(clock.employeeId) === -1) {
                return false;
            }

            if (filterByLabelIds.length && filterByLabelIds.indexOf(clock.scheduled_shift?.label?.id) === -1) {
                return false;
            }

            if (isOfflineModeEnabled && clock.has_timesheet_offline_conflict && clock.actual_clock?.['clock_in']) {
                return false;
            }

            return result && positionCatFlag;
        }

        CTTimesheetService.getFilteredClocks = function (filters, filtersMap, passedData) {
            var categoryId = filtersMap['categoryId'];
            var positionId = filtersMap['positionId'];
            var filterByUsersIds = filtersMap['filterByUsersIds'];
            var filterByLabelIds = filtersMap['filterByLabelIds'];
            var filterByEmployeeTags = filtersMap['filterByEmployeeTags'];
            const filterByEmploymentType = filtersMap['filterByEmploymentType'];
            var filterByClockViolations = filtersMap['filterByClockViolations'];

            var data = passedData || CTTimesheetService.data;
            filterByUsersIds = filterByUsersIds || [];
            filterByLabelIds = filterByLabelIds || [];

            data = _.filter(data.clocks, function (clock) {

                var result = true;
                var positionCatFlag = true;
                var statusFlag = true;
                var employeeStatusFlag = true;

                if (positionId && clock.actual_clock.position.code !== positionId) {
                    positionCatFlag = false;
                } else if (
                    categoryId && clock.actual_clock.position.category.code !== categoryId
                ) {
                    positionCatFlag = false;
                }

                if (filterByUsersIds.length && filterByUsersIds.indexOf(clock.employeeId) === -1) {
                    return false;
                }

                if (filterByEmployeeTags.length && !isEmployeeTagIncluded(clock.employeeId, filterByEmployeeTags)) {
                    return false;
                }

                if (filterByEmploymentType.length && !isEmployeeEmploymentTypeIncluded(clock.employeeId, filterByEmploymentType)) {
                    return false;
                }

                if (filterByClockViolations.length && !isClockHasViolations(clock, filterByClockViolations)) {
                    return false;
                }

                const shiftLabels = clock.scheduled_shift?.labels?.map((label) => label.id) || [];
                if (filterByLabelIds.length && !shiftLabels.some((labelId) => filterByLabelIds.indexOf(labelId) > -1)) {
                    return false;
                }

                if (!filters['approved'] && clock.status === 'APPROVED') {
                    statusFlag = false;
                }

                if (!filters['deleted'] && clock.status === 'DELETED') {
                    statusFlag = false;
                }

                clock.warnings = clock.warnings || [];

                if (
                    !filters['open'] &&
                    clock.status === 'PENDING_APPROVAL'
                ) {
                    result = false;
                }

                if (
                    filters['open'] &&
                    clock.status === 'PENDING_APPROVAL'
                ) {
                    if (!filters['withWarning'] && clock.warnings.length) {
                        result = false;
                    }

                    if (filters['open'] && !filters['withoutWarning'] && !clock.warnings.length) {
                        result = false;
                    }
                }

                if (timeSheetAdjusmentsSettings.employee_protest_enabled && (filters['approved'] || filters['deleted'])) {
                    employeeStatusFlag = false;

                    if (timeSheetAdjusmentsSettings.tcaf_mode === 'FULL') {
                        var allFullFiltersSelected = filters['pending'] && filters['confirmedByEmployer'] && filters['confirmed'] && filters['protested'];
                        var allFullFiltersUnselected = !filters['pending'] && !filters['confirmedByEmployer'] && !filters['confirmed'] && !filters['protested'];

                        if ((allFullFiltersSelected || allFullFiltersUnselected)) {
                            employeeStatusFlag = true;
                        } else {
                            if (
                                filters['pending'] &&
                                clock.employee_status === CTTimesheetService.EMPLOYEE_STATUSES_ACK.PENDING_EMPLOYEE_APPROVAL
                            ) {
                                employeeStatusFlag = true;
                            }

                            if (
                                filters['protested'] &&
                                clock.employee_status === CTTimesheetService.EMPLOYEE_STATUSES_ACK.EMPLOYEE_PROTESTED
                            ) {
                                employeeStatusFlag = true;
                            }

                            if (
                                filters['confirmed'] &&
                                clock.employee_status === CTTimesheetService.EMPLOYEE_STATUSES_ACK.EMPLOYEE_APPROVED
                            ) {
                                employeeStatusFlag = true;
                            }

                            if (
                                filters['confirmedByEmployer'] &&
                                clock.employee_status === CTTimesheetService.EMPLOYEE_STATUSES_ACK.EMPLOYER_APPROVED
                            ) {
                                employeeStatusFlag = true;
                            }
                        }
                    } else {
                        var allLightFiltersSelected = filters['pending'] && filters['acknowledgedByEmployee'];
                        var allLightFiltersUnselected = !filters['pending'] && !filters['acknowledgedByEmployee'];

                        if ((allLightFiltersSelected || allLightFiltersUnselected)) {
                            employeeStatusFlag = true;
                        } else {
                            if (
                                filters['pending'] &&
                                clock.employee_status === CTTimesheetService.EMPLOYEE_STATUSES_ACK.PENDING_EMPLOYEE_APPROVAL
                            ) {
                                employeeStatusFlag = true;
                            }

                            if (
                                filters['acknowledgedByEmployee'] &&
                                clock.employee_status === CTTimesheetService.EMPLOYEE_STATUSES_ACK.EMPLOYEE_ACKNOWLEDGED
                            ) {
                                employeeStatusFlag = true;
                            }
                        }
                    }
                }

                return result && statusFlag && positionCatFlag && employeeStatusFlag;
            });

            return data;
        };

        /* Update Data */
        CTTimesheetService.flattenAndUpdateData = function (data) {
            var normalizedData = flattenData(data);

            normalizedData.clocks.forEach(function (newClock) {
                var clockIndex = _.findIndex(CTTimesheetService.data.clocks, function (clock) {
                    return ((clock.actual_clock.id === newClock.actual_clock.id) && (newClock.date === clock.date));
                });

                if (clockIndex > -1) {
                    newClock.scheduled_shift = newClock.scheduled_shift || CTTimesheetService.data.clocks[clockIndex].scheduled_shift;
                    //Update is_editable if it's already there
                    if(CTTimesheetService.data.clocks[clockIndex].is_editable) {
                        newClock.is_editable = true;
                    }

                    CTTimesheetService.data.clocks[clockIndex] = angular.extend({}, CTTimesheetService.data.clocks[clockIndex], newClock);

                    if (CTTimesheetService.data.clocks[clockIndex].actual_clock.error_reason &&
                        CTTimesheetService.data.clocks[clockIndex].actual_clock.error_reason.id) {
                        var reason = _.find(normalizedData['error_reasons'], function (item) {
                            return item.id === CTTimesheetService.data.clocks[clockIndex].actual_clock.error_reason.id;
                        });

                        if (reason) {
                            CTTimesheetService.data.clocks[clockIndex].actual_clock.error_reason = reason;
                        }
                    }

                } else {
                    if (newClock.isExtendedFromPreviousDay) {
                        var shiftFirstPart = _.find(CTTimesheetService.data.clocks, function (clock) {
                            return (
                                (clock.actual_clock.id === newClock.actual_clock.id) &&
                                moment(clock.date).isSame(moment(newClock.date).subtract(1, 'day'), 'day')
                            );
                        });

                        if (shiftFirstPart && shiftFirstPart.scheduled_shift) {
                            newClock.scheduled_shift = shiftFirstPart.scheduled_shift;
                            newClock.scheduled = shiftFirstPart.scheduled;
                        }

                    }

                    if (newClock.actual_clock.error_reason && newClock.actual_clock.error_reason.id) {
                        var reason = _.find(normalizedData['error_reasons'], function (item) {
                            return item.id === newClock.actual_clock.error_reason.id;
                        });

                        if (reason) {
                            newClock.actual_clock.error_reason = reason;
                        }
                    }

                    CTTimesheetService.data.clocks.push(newClock);
                }

            });

            normalizedData.errors.forEach(function (newError) {
                var errorIndex = _.findIndex(CTTimesheetService.data.errors, function (error) {
                    return error.actual_clock.id === newError.actual_clock.id;
                });

                if (errorIndex > -1) {
                    CTTimesheetService.data.errors[errorIndex] = angular.copy(newError);
                } else {
                    CTTimesheetService.data.errors.push(angular.copy(newError));
                }
            });

            return normalizedData;
        };

        //Remove a clock entry by id
        CTTimesheetService.removeClock = function (clockId) {
            CTTimesheetService.data.clocks = _.reject(CTTimesheetService.data.clocks, function (clock) {
                return clock.actual_clock.id === clockId;
            });
        };

        CTTimesheetService.updateOfflineClock = function (clockId) {
            var clockIndex = _.findIndex(CTTimesheetService.data.clocks, function (clock) {
                return clock.actual_clock.id === clockId;
            });

            if (clockIndex > -1) {
                var clock = CTTimesheetService.data.clocks[clockIndex];
                clock['has_timesheet_offline_conflict'] = false;
            }
        };

        /**
         * Make clock as archived
         *
         * @param clockId
         */
        CTTimesheetService.archiveTimeCard = function (clockId) {
            /**
             * Get copy from clocks to change what ever we want
             */
            var clocks = CTTimesheetService.data.clocks.slice();

            /**
             * Assign the new clocks to the data object
             */
            CTTimesheetService.data.clocks = clocks.map(function (clock) {
                if (clock.actual_clock.id == clockId) {
                    $.extend(clock, {is_archived: true, status: 'DELETED'});
                    clock.is_editable = false;
                }
                return clock;
            });
        };

        //remove a timesheet error by id
        CTTimesheetService.removeError = function (errorId) {
            CTTimesheetService.data.errors = _.reject(CTTimesheetService.data.errors, function (error) {
                return error.actual_clock.id === errorId;
            });
        };

        //update a timesheet error id
        CTTimesheetService.updateErrorId = function (originalErrorId, newErrorId) {
            var errorIndex = _.findIndex(CTTimesheetService.data.errors, function (error) {
                return error.actual_clock.id === originalErrorId;
            });

            if (errorIndex > -1) {
                var error = CTTimesheetService.data.errors[errorIndex];
                error.actual_clock.id = newErrorId;
            }
        };

        //Update some rendring details e.g: lazy data rendering
        CTTimesheetService.updateRenderingDetails = function (entity, value, employeeId) {
            if (employeeId) {
                for (var i in CTTimesheetService.data.clocks) {
                    var clock = CTTimesheetService.data.clocks[i];

                    if (clock.employeeId == employeeId) {
                        if (entity === 'toggled') {
                            clock['renderingDetails'][entity] = !clock['renderingDetails'][entity];
                        } else {
                            clock['renderingDetails'][entity] = value;
                        }
                    }
                }
            } else {
                for (var i in CTTimesheetService.data.clocks) {
                    var clock = CTTimesheetService.data.clocks[i];

                    clock['renderingDetails'][entity] = value;
                }
            }
        };

        //Make clock in approve state
        CTTimesheetService.approveClocks = function (clocks) {
            clocks.forEach(function (clockData) {
                var clock = _.find(CTTimesheetService.data.clocks, function (entry) {
                    return entry.actual_clock.id === clockData.id;
                });

                if (clock) {
                    clock['status'] = 'APPROVED';

                    if (timeSheetAdjusmentsSettings.employee_protest_enabled) {
                        clock['employee_status'] = clockData.employee_status;
                    }
                } else {
                    console.error("the clock u r trying to approve doesn't exisit", clockData.id);
                }
            });
        };

        CTTimesheetService.setDistributed = function(code, value) {
            distributed[code] = {};
            distributed[code].value = value;
            distributed.value += value;
        };

        CTTimesheetService.getDistributed = function() {
            return distributed;
        };

        //Find clock by clockid
        CTTimesheetService.getClockById = function (clockId, clockDate) {
            var clock = _.find(CTTimesheetService.data.clocks, function (entry) {
                return (entry.actual_clock.id === clockId && clockDate === entry.date);
            });

            return angular.copy(clock);
        };

        var getClockViolationsCodes = function (timesheetColumns) {
            var clockViolationsCodes = [];
            var timesheetColumnsCodes = Object.keys(timesheetColumns || {}) || [];

            for (var i in timesheetColumnsCodes) {
                var columnKey = timesheetColumnsCodes[i];
                var columnValue = timesheetColumns[columnKey];

                if (columnValue) {
                    if (['overtime', 'doubleOvertime', 'shifts_overtime', 'hours_overtime', 'rest_day_overtime'].indexOf(columnKey) > -1 && clockViolationsCodes.indexOf('OVERTIME') === -1) {
                        clockViolationsCodes.push('OVERTIME');
                    }

                    if (columnKey === 'breakPenalties' && !clockViolationsCodes.includes(CLOCKS_VIOLATIONS_MAP.BREAKS_PREMIUMS.code)) {
                        clockViolationsCodes.push(CLOCKS_VIOLATIONS_MAP.BREAKS_PREMIUMS.code);
                    }

                    if (columnKey === 'employeeIgnore' && clockViolationsCodes.indexOf(CLOCKS_VIOLATIONS_MAP.EMPLOYEE_IGNORED.code) === -1) {
                        clockViolationsCodes.push(CLOCKS_VIOLATIONS_MAP.EMPLOYEE_IGNORED.code);
                    }

                    if (columnKey === 'breaks_premiums_ignored_by_waiver_on_file' && clockViolationsCodes.indexOf(CLOCKS_VIOLATIONS_MAP.BREAKS_PREMIUMS_IGNORED_BY_WAIVER_ON_FILE.code) === -1) {
                        clockViolationsCodes.push(CLOCKS_VIOLATIONS_MAP.BREAKS_PREMIUMS_IGNORED_BY_WAIVER_ON_FILE.code);
                    }

                    if (columnKey === 'employerIgnore' && clockViolationsCodes.indexOf(CLOCKS_VIOLATIONS_MAP.EMPLOYER_IGNORE.code) === -1) {
                        clockViolationsCodes.push(CLOCKS_VIOLATIONS_MAP.EMPLOYER_IGNORE.code);
                    }

                    if (columnKey === 'callIn' && clockViolationsCodes.indexOf('REPORTING_TIME') === -1) {
                        clockViolationsCodes.push('REPORTING_TIME');
                    }

                    if (columnKey === 'splitShiftPenalties' && clockViolationsCodes.indexOf('SPLIT_SHIFT') === -1) {
                        clockViolationsCodes.push('SPLIT_SHIFT');
                    }

                    if (columnKey === 'premiumPay' && clockViolationsCodes.indexOf('FWW') === -1) {
                        clockViolationsCodes.push('FWW');
                    }

                    if (columnKey === 'premiumPay' && clockViolationsCodes.indexOf('RTR') === -1) {
                        clockViolationsCodes.push('RTR');
                    }

                    if (columnKey === 'spreadOfHours' && clockViolationsCodes.indexOf('SPREAD_OF_HOURS') === -1) {
                        clockViolationsCodes.push('SPREAD_OF_HOURS');
                    }

                    if (columnKey === 'rest_day_hours_worked' && clockViolationsCodes.indexOf('PH_REST_DAY') === -1) {
                        clockViolationsCodes.push('PH_REST_DAY');
                    }
                }
            }

            if (isPunchPhotosAllowed && clockViolationsCodes.indexOf(CLOCKS_VIOLATIONS_MAP.PHOTO_ISSUES.code) === -1) {
                clockViolationsCodes.push(CLOCKS_VIOLATIONS_MAP.PHOTO_ISSUES.code);
            }

            return clockViolationsCodes;
        };

        const filterTroncPots = (pots) => {
            return pots?.filter((pot) => {
                return [
                    TRONC_POTS.TRONC_POINTS,
                    TRONC_POTS.TRONC_FIXED_RATE
                ].includes(pot.code)
            }) ?? [];
        };

        var getClockViewTime = function (clock, startDate, brand) {
            var clockIn = clock.actual_clock.clock_in;
            var clockOut = clock.actual_clock.clock_out;

            if (clock.isExtendedFromPreviousDay || clock.isExtendedOverNextDay) {
                var brandBusinessDay = CTTimesheetService.findBrandOpenAndCloseTime(brand, $filter("formatDateIgnoreTimeZone")(clock.date, "YYYY-MM-DD"));

                if (clock.isExtendedFromPreviousDay) {
                    clockIn = Utils.getISODate(brandBusinessDay.openTime);
                }

                if (clock.isExtendedOverNextDay) {
                    clockOut = Utils.getISODate(brandBusinessDay.closeTime);
                }
            }

            return {
                clock_in: clockIn,
                clock_out: clockOut
            }
        };

        //Get day all employees data
        CTTimesheetService.getDayAllEmployeesData = function (filters, filtersMap, startDate) {
            var data = CTTimesheetService.getFilteredClocks(filters, filtersMap);
            let isBreakWaiverOnFileEnabled = CTTimesheetService.isBreakWaiverOnFileSettingEnabled();
            var isTimesheetLocked =
                timesheetWeeksDetails['current_week'] &&
                timesheetWeeksDetails['current_week']['lock_status'] &&
                timesheetWeeksDetails['current_week']['lock_status'].isLocked;

            var result = {
                colsCount: 10,
                type: "ALL_EMPLOYEES_DAY",
                sectionId: "ALL_EMPLOYEES_DAY_0",
                data: [],
                totals: {
                    rate: '--',
                    net_shift_seconds: 0,
                    double_overtime: 0,
                    spread_of_hours: 0,
                    overtime: 0,
                    shifts_overtime: 0,
                    hours_overtime: 0,
                    paid_breaks: 0,
                    paid_time: 0,
                    call_ins_duration: 0,
                    split_shift_penalty_amount: 0,
                    unpaid_breaks: 0,
                    total_meals_deduction: 0,
                    scheduled: 0,
                    clock_in: '--',
                    clock_out: '--',
                    amount: 0,
                    variance: 0,
                    tips: 0,
                    sick_time: 0,
                    earned_hours: 0,
                    penalties_amount: 0,
                    right_to_rest_amount: 0,
                    stationsExtraPayTime: 0,
                    differentialPayAmount: 0,
                    incentiveExtraPayAmount: 0,
                    employee_status: '--',
                    rest_day_hours: 0,
                    rest_day_overtime: 0,
                },
                cols: {
                    role: true,
                    rate: true,
                    labels: false,
                    scheduled: !activeBrand.untimed_shift_enabled,
                    clockIn: true,
                    clockOut: true,
                    paidTime: true,
                    shiftValue: false,
                    paidBreaks: false,
                    unpaidBreaks: false,
                    total_meals_deduction: false,
                    overtime: false,
                    shifts_overtime: false,
                    hours_overtime: false,
                    amount: true,
                    spreadOfHours: false,
                    doubleOvertime: false,
                    tips: false,
                    sick_time: false,
                    callIn: false,
                    splitShiftPenalties: false,
                    breakPenalties: false,
                    employeeIgnore: false,
                    breaks_premiums_ignored_by_waiver_on_file: false,
                    employerIgnore: false,
                    premiumPay: false,
                    differentialPay: false,
                    stationsExtraPay: false,
                    incentiveExtraPay: false,
                    employee_status: timeSheetAdjusmentsSettings.employee_protest_enabled,
                    rest_day_hours_worked: false,
                    rest_day_overtime: false,
                }
            };

            const troncSources = activeBrand?.tronc?.sources ?? [];
            const troncPots = filterTroncPots(activeBrand?.tronc?.pots);
            for (const source of troncSources) {
                for (const pot of troncPots) {
                    const identifier = tipsDistributionSharedFactory.getClockTimeSourcePotIdentifier(source.code, pot.code);
                    result.cols[identifier] = false;
                    result.totals[identifier] = 0;
                }
            }

            if (data) {

                result.data = _.chain(data)
                    .groupBy(function (entity) {
                        return entity.employeeId;
                    })
                    .map(function (vals, key) {
                        var totals = {
                            rate: '--',
                            net_shift_seconds: 0,
                            double_overtime: 0,
                            spread_of_hours: 0,
                            overtime: 0,
                            shifts_overtime: 0,
                            hours_overtime: 0,
                            paid_breaks: 0,
                            paid_time: 0,
                            call_ins_duration: 0,
                            split_shift_penalty_amount: 0,
                            unpaid_breaks: 0,
                            total_meals_deduction: 0,
                            tips: 0,
                            scheduled: 0,
                            clock_in: '--',
                            clock_out: '--',
                            amount: 0,
                            variance: 0,
                            sick_time: 0,
                            earned_hours: 0,
                            penalties_amount: 0,
                            premium_pay: 0,
                            right_to_rest_amount: 0,
                            stationsExtraPayTime: 0,
                            differentialPayAmount: 0,
                            incentiveExtraPayAmount: 0,
                            employee_status: '--'
                        };

                        for (const source of troncSources) {
                            for (const pot of troncPots) {
                                const identifier = tipsDistributionSharedFactory.getClockTimeSourcePotIdentifier(source.code, pot.code);
                                totals[identifier] = 0;
                            }
                        }

                        for(var employeeIndex in vals ){
                            totals.net_shift_seconds += vals[employeeIndex].net_shift_seconds;
                            totals.double_overtime += vals[employeeIndex].double_overtime;
                            totals.spread_of_hours += vals[employeeIndex].spread_of_hours;
                            totals.overtime += vals[employeeIndex].overtime;
                            totals.shifts_overtime += vals[employeeIndex].overtime_shift_weights || 0;
                            totals.hours_overtime += vals[employeeIndex].overtime;
                            totals.paid_breaks += vals[employeeIndex].paid_breaks;
                            totals.paid_time += vals[employeeIndex].paid_time;
                            totals.unpaid_breaks += vals[employeeIndex].unpaid_breaks;
                            totals.total_meals_deduction += vals[employeeIndex].total_meals_deduction || 0;
                            totals.tips += (vals[employeeIndex].tips && vals[employeeIndex].tips.amount) || 0;
                            totals.penalties_amount += vals[employeeIndex].penalties_amount || 0;
                            totals.right_to_rest_amount += vals[employeeIndex].right_to_rest_amount || 0;
                            totals.premium_pay += vals[employeeIndex].premium_pay || 0;
                            totals.differentialPayAmount += vals[employeeIndex].differentialPayAmount || 0;
                            totals.stationsExtraPayTime += vals[employeeIndex].stationsExtraPayTime || 0;
                            totals.incentiveExtraPayAmount += vals[employeeIndex].actual_clock.incentive_payments_amount || 0;

                            const employeeTroncSources = (vals[employeeIndex]?.tronc?.sources) || [];

                            const isTroncNamingConventionApplied = tipsDistributionSharedFactory.isTroncNamingConventionApplied(activeBrand.team_live_country_code)
                            for (const source of employeeTroncSources) {
                                const identifier = tipsDistributionSharedFactory.getClockTimeSourcePotIdentifier(source.code, source.pot_code);
                                source.identifier = identifier;
                                source.potName = tipsDistributionSharedFactory.getTroncPotTitle(
                                    source.pot_code,
                                    isTroncNamingConventionApplied,
                                );
                                totals[identifier] += (source.amount ?? 0) + (source.adjustment ?? 0);
                            }

                            totals.split_shift_penalty_amount += (vals[employeeIndex].actual_clock.split_shift_penalty  && vals[employeeIndex].actual_clock.split_shift_penalty.status === "INCLUDED" && vals[employeeIndex].actual_clock.split_shift_penalty.amount) || 0;
                            totals.sick_time += (vals[employeeIndex].actual_clock && vals[employeeIndex].actual_clock.sick_leave_duration) || 0;
                            totals.call_ins_duration += (vals[employeeIndex].actual_clock && vals[employeeIndex].actual_clock.call_in && vals[employeeIndex].actual_clock.call_in.status === "APPROVED" && vals[employeeIndex].actual_clock.call_in.duration) || 0;
                            totals.amount += vals[employeeIndex].amount;

                            vals[employeeIndex].variance = vals[employeeIndex].paid_time - (vals[employeeIndex].scheduled || 0);
                            totals.variance += vals[employeeIndex].variance;
                        }
                        return {
                            sectionRowId: "SECTION_ROW_" + key,
                            employeeId: key,
                            clocks: vals,
                            totals:totals
                        };
                    })
                    .value();

                //Calculate totals
                result.data.forEach(function (employee) {
                    employee.clocks.forEach(function (clock) {
                        const isBreakPremiumsEnabled = CTTimesheetService.getBreaksRulesSet(clock.date);

                        if (clock.scheduled_shift?.labels?.length) {
                            result.cols.labels = true;
                        }

                        clock.view_info = getClockViewTime(clock, startDate, activeBrand);

                        //find totals
                        if (typeof(clock.spread_of_hours) !== "undefined" && activeBrand.team_live_country_code !== "UK") {
                            result.cols.spreadOfHours = true;
                            result.totals.spread_of_hours += clock.spread_of_hours;
                        }

                        if (typeof(clock.double_overtime) !== "undefined" && activeBrand.team_live_country_code !== "UK") {
                            result.cols.doubleOvertime = true;
                            result.totals.double_overtime += clock.double_overtime;
                        }

                        if (typeof(clock.penalties_amount) !== "undefined") {
                            result.cols.premiumPay = true;
                            result.totals.penalties_amount += clock.penalties_amount;
                        }

                        if (typeof(clock.right_to_rest_amount) !== "undefined") {
                            result.cols.premiumPay = true;
                            result.totals.right_to_rest_amount += clock.right_to_rest_amount;
                        }

                        if (clock.actual_clock && clock.actual_clock.differential_pay && clock.actual_clock.differential_pay.amount) {
                            result.cols.differentialPay = true;
                            result.totals.differentialPayAmount += clock.actual_clock.differential_pay.amount;
                        }

                        if (clock.actual_clock?.stations_extra_pay?.total_job_title_seconds) {
                            result.cols.stationsExtraPay = true;
                            result.totals.stationsExtraPayTime += clock.actual_clock.stations_extra_pay.total_job_title_seconds;
                        }

                        if (clock?.actual_clock?.incentive_payments_amount) {
                            result.cols.incentiveExtraPay = true;
                            result.totals.incentiveExtraPayAmount += clock.actual_clock.incentive_payments_amount;
                        }

                        var showShiftValueCol = false;

                        for (var i in activeBrand.employee_payment_types) {
                            var paymentType = activeBrand.employee_payment_types[i];

                            if (paymentType.type === "WEIGHTED_SHIFT" || (paymentType.type === "SALARIED" && paymentType.track_mode === "WEIGHTED_SHIFT")) {
                                showShiftValueCol = true;
                            }
                        }

                        if (showShiftValueCol && CTTimesheetService.shiftBasedScheduling) {
                            result.cols.shiftValue = true;
                        }

                        if (activeBrand.team_live_country_code !== "UK") {
                            result.cols.overtime = true;
                        }

                        if (activeBrand.team_live_country_code === "UK") {
                            if (activeBrand.pay_types_overtime) {
                                var clockDate = moment(clock.date);
                                var salariedOTVersions = activeBrand.pay_types_overtime.salaried_weekly_overtime;
                                var shiftyOTVersions = activeBrand.pay_types_overtime.weighted_shift_weekly_overtime;
                                var latestSalariedOTSetting = null;
                                var latestShiftyOTSetting = null;

                                for (var i in salariedOTVersions) {
                                    var salariedOT = salariedOTVersions[i];
                                    if (moment(salariedOT.start_date).isSameOrBefore(clockDate)) {
                                        latestSalariedOTSetting = salariedOT;
                                        break;
                                    }
                                }

                                for (var i in shiftyOTVersions) {
                                    var shiftyOT = shiftyOTVersions[i];
                                    if (moment(shiftyOT.start_date).isSameOrBefore(clockDate)) {
                                        latestShiftyOTSetting = shiftyOT;
                                        break;
                                    }
                                }

                                if (clock.actual_clock.overtime && clock.actual_clock.overtime.is_weekly_entitled) {

                                    if ((latestSalariedOTSetting && latestSalariedOTSetting.cost_unit === 'HOUR' && latestSalariedOTSetting.is_active) ||
                                        (latestShiftyOTSetting && latestShiftyOTSetting.cost_unit === 'HOUR' && latestShiftyOTSetting.is_active)) {
                                        result.cols.hours_overtime = true;
                                    }
                                    if ((latestSalariedOTSetting && latestSalariedOTSetting.cost_unit === 'SHIFT' && latestSalariedOTSetting.is_active) ||
                                        (latestShiftyOTSetting && latestShiftyOTSetting.cost_unit === 'SHIFT' && latestShiftyOTSetting.is_active)) {
                                        result.cols.shifts_overtime = true;
                                    }
                                }
                            }
                        }

                        if (
                            activeBrand.services.includes(brandServices.SERVICES.TIPS_DISTRIBUTION)
                        ) {
                            result.cols.tips = true;
                            result.totals.tips += ((clock.tips && clock.tips.amount) || 0);
                        } else if (CTTimesheetService.isDistributionSectionShown) {
                            const employeeTroncSources = clock?.tronc?.sources ?? [];
                            const employeeSourcesMap = {};

                            for (const source of employeeTroncSources) {
                                const identifier = tipsDistributionSharedFactory.getClockTimeSourcePotIdentifier(source.code, source.pot_code);
                                employeeSourcesMap[identifier] = source;
                                result.totals[identifier] += (source.amount ?? 0) + (source.adjustment ?? 0);
                            }

                            for (const source of troncSources) {
                                for (const pot of troncPots) {
                                    const identifier = tipsDistributionSharedFactory.getClockTimeSourcePotIdentifier(source.code, pot.code);
                                    if (
                                        source.status === 'ACTIVE' ||
                                        employeeSourcesMap[identifier]) {
                                        result.cols[identifier] = true;
                                    }
                                }
                            }

                            clock.troncSources = employeeSourcesMap;
                        }

                        result.cols.splitShiftPenalties = ['CA', 'DC'].indexOf(CTTimesheetService.getSplitShiftPenaltySettings(clock.date)) > -1;

                        if(result.cols.splitShiftPenalties) {
                           result.totals.split_shift_penalty_amount += (clock.actual_clock.split_shift_penalty && clock.actual_clock.split_shift_penalty.status == 'INCLUDED' && clock.actual_clock.split_shift_penalty.amount) || 0;
                        }

                        if (isSickLeaveEnabled && activeBrand.team_live_country_code !== "UK") {
                            result.cols.sick_time = true;
                            result.totals.sick_time += clock.actual_clock.sick_leave_duration;
                        }

                        if (
                            CTTimesheetService.employerTimesheetTipsSettings &&
                            CTTimesheetService.employerTimesheetTipsSettings.enable_tip_prompt &&
                            canManageHourlyWagesAccess
                        ) {
                            result.cols.tips = true;
                            result.totals.tips += clock.tips && clock.tips.amount || 0;
                        }

                        if (CTTimesheetService.callInSettings && CTTimesheetService.callInSettings.length > 0 && activeBrand.team_live_country_code !== "UK") {
                            result.cols.callIn = CTTimesheetService.getCallInsSettings(clock.date) !== "NONE";
                            result.totals.call_ins_duration += clock.actual_clock.call_in && ["APPROVED", "SYSTEM_APPROVED"].indexOf(clock.actual_clock.call_in.status) > -1  && (clock.actual_clock.call_in.duration || 0);
                        }

                        result.cols.breakPenalties = isBreakPremiumsEnabled && activeBrand.team_live_country_code !== "UK";

                        result.cols.employeeIgnore = (missedBreakAction === "WAIVE_MISSED" && (activeBrand.team_live_country_code === "UK" || activeBrand.team_live_country_code === "US"));
                        result.cols.employerIgnore = isBreakPremiumsEnabled;
                        result.cols.breaks_premiums_ignored_by_waiver_on_file = isBreakPremiumsEnabled && isBreakWaiverOnFileEnabled;

                        if (result.cols.breakPenalties) {
                            var breaksPenaltySeconds = clock['breaks_penalty_seconds'] || 0;
                            clock.earned_hours = breaksPenaltySeconds;
                            employee.totals.earned_hours += breaksPenaltySeconds;
                            result.totals.earned_hours += breaksPenaltySeconds;
                        }

                        //Show paid breaks column if any of the values is positive
                        if (clock.paid_breaks) {
                            result.cols.paidBreaks = true;
                        }

                        //Show un-paid breaks column if any of the values is positive
                        if (clock.unpaid_breaks) {
                            result.cols.unpaidBreaks = true;
                        }

                        if (typeof(clock.total_meals_deduction) !== "undefined" && activeBrand.team_live_country_code !== "UK") {

                            result.cols.total_meals_deduction = true;
                            result.totals.total_meals_deduction += clock.total_meals_deduction;
                        }

                        if (clock.actual_clock.clock_in && clock.actual_clock.clock_out) {
                            clock.isTimeZoneChanged = checkTimeZoneOffsetDifference(clock.actual_clock.clock_in, clock.actual_clock.clock_out, activeBrand.timezoneName);
                        }

                        result.totals.net_shift_seconds += clock.net_shift_seconds;
                        result.totals.overtime += clock.overtime;
                        result.totals.shifts_overtime += clock.overtime_shift_weights || 0;
                        result.totals.hours_overtime += clock.overtime;
                        result.totals.paid_breaks += clock.paid_breaks;
                        result.totals.paid_time += clock.paid_time;
                        result.totals.unpaid_breaks += clock.unpaid_breaks;
                        result.totals.amount += clock.amount;

                        result.cols.scheduled = !activeBrand.untimed_shift_enabled;

                        if (clock.scheduled) {
                            result.totals.scheduled += clock.scheduled;
                        }

                        if (clock.rest_day_pay) {
                            result.cols.rest_day_hours_worked = true;
                            result.totals.rest_day_hours += clock.rest_day_pay.net_shift_seconds;

                            if (clock.rest_day_pay && clock.rest_day_pay.overtime) {
                                result.cols.rest_day_overtime = true;
                                result.totals.rest_day_overtime += clock.rest_day_pay.overtime.seconds;
                            }
                        }
                        var date = $filter('formatDateIgnoreTimeZone')(clock.date, "YYYY-MM-DD");

                        clock.isNotWithinEmploymentPeriod = false;
                        clock.isNotWithinActiveLocationPeriod = false;

                        if (!TSUsersService.users[clock.employeeId].isDateWithinEmploymentPeriod(date)) {
                            clock.isNotWithinEmploymentPeriod = true;
                        }
                        if (!TSUsersService.users[clock.employeeId].isDateWithinActiveLocationPeriod(date)) {
                            clock.isNotWithinActiveLocationPeriod = true;
                        }

                        clock.isDeletedAndNotWithinEmploymentPeriod = clock.category == "SCHEDULED_DELETED" && (clock.isNotWithinEmploymentPeriod || clock.isNotWithinActiveLocationPeriod);
                    });
                    employee.canAddNewEntries = !isTimesheetLocked;
                    var brandUser = activeBrandUsers[employee.employeeId];
                    var employeeActivePaytype = brandUser && TSUsersService.getUserActivePayType(brandUser.id, startDate);
                    employee.hasClosedPDS = weekPaysheetTypesInfo[employeeActivePaytype] && weekPaysheetTypesInfo[employeeActivePaytype].is_pds_closed;

                });

                result.totals.amount = (result.totals.amount / 100).toFixed(2);
                result.totals.premium_pay = ((result.totals.right_to_rest_amount + result.totals.penalties_amount) / 100).toFixed(2);
                result.totals.differentialPayAmount = (result.totals.differentialPayAmount / 100).toFixed(2);
                result.currency = currency;

                if (activeBrand.services.includes(brandServices.SERVICES.TIPS_DISTRIBUTION)) {
                    distributed.value = 0;
                    distributed.total = 0;

                    CTTimesheetService.setDistributed("TIPS", result.totals.tips / 100);
                } else {
                    distributed.value = 0;
                    distributed.total = 0;

                    for (const source of troncSources) {
                        let sourceTotal = 0;
                        for (const pot of troncPots) {
                            const identifier = tipsDistributionSharedFactory.getClockTimeSourcePotIdentifier(source.code, pot.code);
                            sourceTotal += (result.totals[identifier] ?? 0)
                        }
                        CTTimesheetService.setDistributed(source.code, Utils.roundFloat((sourceTotal / 100) || 0, 2));
                    }
                }

                //find columns count
                result.colsCount = 0;
                for (var i in result.cols) {
                    if (result.cols[i]) {
                        result.colsCount++;
                    }
                }
            }

            clockViolationsList = getClockViolationsCodes(result['cols']);

            return result;
        };

        CTTimesheetService.updateClocksEditability = function () {
            var clocks = CTTimesheetService.data.clocks;
            for (var i in clocks) {
                var clock = clocks[i];
                clock.is_editable = findClockEntryEdiability(clock);
            }
        };

        //get week all employees data
        CTTimesheetService.getWeekAllEmployeesData = function (filters, filtersMap, passedData, startDate) {

            //take data passed or deafult to timeSheetServiceData
            var data = CTTimesheetService.getFilteredClocks(filters, filtersMap, passedData);
            let isBreakWaiverOnFileEnabled = CTTimesheetService.isBreakWaiverOnFileSettingEnabled();
            var isTimesheetLocked =
                timesheetWeeksDetails['current_week'] &&
                timesheetWeeksDetails['current_week']['lock_status'] &&
                timesheetWeeksDetails['current_week']['lock_status'].isLocked;
            clockViolationsList = [];
            var sections = [];

            const troncSources = activeBrand?.tronc?.sources ?? [];
            const troncPots = filterTroncPots(activeBrand?.tronc?.pots);

            if (data.length > 0) {
                sections = _.chain(data)
                    .groupBy(function (entity) {
                        return entity.employeeId;
                    })
                    .map(function (vals, key) {
                        var data = _.chain(vals)
                            .groupBy(function (entity) {
                                return entity.date;
                            })
                            .map(function (vals, key) {
                                return {
                                    sectionRowId: "SECTION_ROW_" + moment(key).format("D"),
                                    date: key,
                                    clocks: vals
                                };
                            })
                            .value();

                        var returnedMappedObject = {
                            colsCount: 10,
                            employeeId: key,
                            type: "ALL_EMPLOYEES_WEEK",
                            sectionId: "EMPLOYEE_" + key,
                            data: data,
                            totals: {
                                rate: '--',
                                net_shift_seconds: 0,
                                double_overtime: 0,
                                overtime: 0,
                                shifts_overtime: 0,
                                hours_overtime: 0,
                                paid_breaks: 0,
                                paid_time: 0,
                                call_ins_duration: 0,
                                split_shift_penalty_amount: 0,
                                unpaid_breaks: 0,
                                total_meals_deduction: 0,
                                scheduled: 0,
                                clock_in: '--',
                                clock_out: '--',
                                amount: 0,
                                variance: 0,
                                spread_of_hours: 0,
                                tips: 0,
                                sick_time: 0,
                                earned_hours: 0,
                                penalties_amount: 0,
                                right_to_rest_amount: 0,
                                differentialPayAmount: 0,
                                stationsExtraPayTime: 0,
                                incentiveExtraPayAmount: 0,
                                employee_status: '--',
                                rest_day_hours: 0,
                                rest_day_overtime: 0,
                            },
                            cols: {
                                labels: false,
                                role: true,
                                rate: true,
                                scheduled: true,
                                clockIn: '--',
                                clockOut: '--',
                                paidTime: true,
                                shiftValue: false,
                                paidBreaks: false,
                                unpaidBreaks: false,
                                overtime: false,
                                shifts_overtime: false,
                                hours_overtime: false,
                                amount: true,
                                spreadOfHours: false,
                                doubleOvertime: false,
                                total_meals_deduction: false,
                                tips: false,
                                sick_time: false,
                                callIn: false,
                                splitShiftPenalties: false,
                                premiumPay: false,
                                breakPenalties: false,
                                employeeIgnore: false,
                                breaks_premiums_ignored_by_waiver_on_file: false,
                                employerIgnore: false,
                                employee_status: timeSheetAdjusmentsSettings.employee_protest_enabled,
                                rest_day_hours_worked: false,
                                rest_day_overtime: false,
                            }
                        };

                        for (const source of troncSources) {
                            for (const pot of troncPots) {
                                const identifier = tipsDistributionSharedFactory.getClockTimeSourcePotIdentifier(source.code, pot.code);
                                returnedMappedObject.totals[identifier] = 0;
                            }
                        }

                        return returnedMappedObject;
                    })
                    .value();

                sections.forEach(function (section) {
                    section.data.forEach(function (sectionRow) {
                        sectionRow.clocks.forEach(function (clock) {
                            clock.isNotWithinEmploymentPeriod = false;
                            clock.isNotWithinActiveLocationPeriod = false;
                            const isBreakPremiumsEnabled = CTTimesheetService.getBreaksRulesSet(clock.date);

                            if (clock.scheduled_shift?.labels?.length) {
                                section.cols.labels = true;
                            }
                            var date = $filter('formatDateIgnoreTimeZone')(clock.date, "YYYY-MM-DD");

                            if (!TSUsersService.users[clock.employeeId].isDateWithinEmploymentPeriod(date)) {
                                clock.isNotWithinEmploymentPeriod = true;
                            }

                            if (!TSUsersService.users[clock.employeeId].isDateWithinActiveLocationPeriod(date)) {
                                clock.isNotWithinActiveLocationPeriod = true;
                            }

                            clock.view_info = getClockViewTime(clock, startDate, activeBrand);

                            clock.isDeletedAndNotWithinEmploymentPeriod = clock.category == "SCHEDULED_DELETED" && (clock.isNotWithinEmploymentPeriod || clock.isNotWithinActiveLocationPeriod);

                            if (clock.rest_day_pay) {
                                section.cols.rest_day_hours_worked = true;
                                section.totals.rest_day_hours += clock.rest_day_pay.net_shift_seconds;

                                if (clock.rest_day_pay && clock.rest_day_pay.overtime) {
                                    section.cols.rest_day_overtime = true;
                                    section.totals.rest_day_overtime += clock.rest_day_pay.overtime.seconds;
                                }
                            }
                            //find totals
                            if (typeof(clock.spread_of_hours) !== "undefined" && activeBrand.team_live_country_code !== "UK") {
                                section.cols.spreadOfHours = true;
                                section.totals.spread_of_hours += clock.spread_of_hours;
                            }

                            if (typeof(clock.double_overtime) !== "undefined" && activeBrand.team_live_country_code !== "UK") {
                                section.cols.doubleOvertime = true;
                                section.totals.double_overtime += clock.double_overtime;
                            }

                            var showShiftValueCol = false;

                            for (var i in activeBrand.employee_payment_types) {
                                var paymentType = activeBrand.employee_payment_types[i];

                                if (paymentType.type === "WEIGHTED_SHIFT" || (paymentType.type === "SALARIED" && paymentType.track_mode === "WEIGHTED_SHIFT")) {
                                    showShiftValueCol = true;
                                }
                            }

                            if (showShiftValueCol && CTTimesheetService.shiftBasedScheduling) {
                                section.cols.shiftValue = true;
                            }

                            if (activeBrand.team_live_country_code !== "UK") {
                                section.cols.overtime = true;
                            }

                            if (activeBrand.team_live_country_code === "UK") {
                                if (activeBrand.pay_types_overtime) {
                                    var clockDate = moment(clock.date);
                                    var salariedOTVersions = activeBrand.pay_types_overtime.salaried_weekly_overtime;
                                    var shiftyOTVersions = activeBrand.pay_types_overtime.weighted_shift_weekly_overtime;
                                    var latestSalariedOTSetting = null;
                                    var latestShiftyOTSetting = null;

                                    for (var i in salariedOTVersions) {
                                        var salariedOT = salariedOTVersions[i];
                                        if (moment(salariedOT.start_date).isSameOrBefore(clockDate)) {
                                            latestSalariedOTSetting = salariedOT;
                                            break;
                                        }
                                    }

                                    for (var i in shiftyOTVersions) {
                                        var shiftyOT = shiftyOTVersions[i];
                                        if (moment(shiftyOT.start_date).isSameOrBefore(clockDate)) {
                                            latestShiftyOTSetting = shiftyOT;
                                            break;
                                        }
                                    }

                                    if (clock.actual_clock.overtime && clock.actual_clock.overtime.is_weekly_entitled) {
                                        if (
                                            (latestSalariedOTSetting && latestSalariedOTSetting.cost_unit === 'HOUR' && latestSalariedOTSetting.is_active) ||
                                            (latestShiftyOTSetting && latestShiftyOTSetting.cost_unit === 'HOUR' && latestShiftyOTSetting.is_active)
                                        ) {
                                            section.cols.hours_overtime = true;
                                        }
                                        if (
                                            (latestSalariedOTSetting && latestSalariedOTSetting.cost_unit === 'SHIFT' && latestSalariedOTSetting.is_active) ||
                                            (latestShiftyOTSetting && latestShiftyOTSetting.cost_unit === 'SHIFT' && latestShiftyOTSetting.is_active)
                                        ) {
                                            section.cols.shifts_overtime = true;
                                        }
                                    }
                                }
                            }

                            if (activeBrand.services.indexOf('TIPS_DISTRIBUTION') > -1) {
                                section.cols.tips = true;
                                section.totals.tips += (clock?.tips?.amount ?? 0);
                            } else if (CTTimesheetService.isDistributionSectionShown) {
                                const employeeTroncSources = clock?.tronc?.sources ?? [];
                                const employeeSourcesMap = {};
                                for (const source of employeeTroncSources) {
                                    const identifier = tipsDistributionSharedFactory.getClockTimeSourcePotIdentifier(source.code, source.pot_code);
                                    employeeSourcesMap[identifier] = source;
                                    section.totals[identifier] += (source.amount ?? 0) + (source.adjustment ?? 0);
                                }

                                for (const source of troncSources) {
                                    for (const pot of troncPots) {
                                        const identifier = tipsDistributionSharedFactory.getClockTimeSourcePotIdentifier(source.code, pot.code);
                                        if (
                                            source.status === 'ACTIVE' ||
                                            employeeSourcesMap[identifier]
                                        ) {
                                            section.cols[identifier] = true;
                                        }
                                    }
                                }

                                clock.troncSources = employeeSourcesMap;
                            }

                            if (
                                CTTimesheetService.employerTimesheetTipsSettings &&
                                CTTimesheetService.employerTimesheetTipsSettings.enable_tip_prompt &&
                                canManageHourlyWagesAccess
                            ) {
                                section.cols.tips = true;
                                section.totals.tips += clock.tips && clock.tips.amount || 0;
                            }

                            if (CTTimesheetService.callInSettings && CTTimesheetService.callInSettings.length > 0 && activeBrand.team_live_country_code !== "UK") {
                                section.cols.callIn = section.cols.callIn || CTTimesheetService.getCallInsSettings(clock.date) !== "NONE";
                                section.totals.call_ins_duration += clock.actual_clock.call_in && ["APPROVED", "SYSTEM_APPROVED"].indexOf(clock.actual_clock.call_in.status) > -1 &&  (clock.actual_clock.call_in.duration || 0);
                            }

                            section.cols.splitShiftPenalties = section.cols.splitShiftPenalties || ['CA', 'DC'].indexOf(CTTimesheetService.getSplitShiftPenaltySettings(clock.date)) > -1;
                            if(section.cols.splitShiftPenalties) {
                                section.totals.split_shift_penalty_amount += (clock.actual_clock.split_shift_penalty && clock.actual_clock.split_shift_penalty.status === 'INCLUDED' && clock.actual_clock.split_shift_penalty.amount) || 0;
                            }

                            section.cols.breakPenalties = section.cols.breakPenalties || isBreakPremiumsEnabled && activeBrand.team_live_country_code !== "UK";

                            section.cols.employeeIgnore = section.cols.employeeIgnore || (missedBreakAction === "WAIVE_MISSED" && (activeBrand.team_live_country_code === "UK" || activeBrand.team_live_country_code === "US"));
                            section.cols.employerIgnore = section.cols.employerIgnore || isBreakPremiumsEnabled;
                            section.cols.breaks_premiums_ignored_by_waiver_on_file = section.cols.breaks_premiums_ignored_by_waiver_on_file || (isBreakPremiumsEnabled && isBreakWaiverOnFileEnabled);

                            if (section.cols.breakPenalties) {
                                var breaksPenaltySeconds = clock['breaks_penalty_seconds'] || 0;
                                clock.earned_hours = breaksPenaltySeconds;
                                section.totals.earned_hours += breaksPenaltySeconds;
                            }

                            if (isSickLeaveEnabled && activeBrand.team_live_country_code !== "UK") {
                                section.cols.sick_time = true;
                                section.totals.sick_time += clock.actual_clock.sick_leave_duration;
                            }

                            if (typeof(clock.total_meals_deduction) !== "undefined" && activeBrand.team_live_country_code !== "UK") {
                                section.cols.total_meals_deduction = true;
                                section.totals.total_meals_deduction += clock.total_meals_deduction;
                            }

                            if (typeof(clock.right_to_rest_amount) !== "undefined") {
                                section.cols.premiumPay = true;
                                section.totals.right_to_rest_amount += clock.right_to_rest_amount;
                            }

                            if (typeof(clock.penalties_amount) !== "undefined") {
                                section.cols.premiumPay = true;
                                section.totals.penalties_amount += clock.penalties_amount;
                            }

                            if (clock.actual_clock && clock.actual_clock.differential_pay && clock.actual_clock.differential_pay.amount) {
                                section.cols.differentialPay = true;
                                section.totals.differentialPayAmount += clock.actual_clock.differential_pay.amount;
                            }

                            if (clock.actual_clock?.stations_extra_pay?.total_job_title_seconds) {
                                section.cols.stationsExtraPay = true;
                                section.totals.stationsExtraPayTime += clock.actual_clock.stations_extra_pay.total_job_title_seconds;
                            }

                            if (clock?.actual_clock?.incentive_payments_amount) {
                                section.cols.incentiveExtraPay = true;
                                section.totals.incentiveExtraPayAmount += clock.actual_clock.incentive_payments_amount;
                            }

                            //Show paid breaks column if any of the values is positive
                            if (clock.paid_breaks) {
                                section.cols.paidBreaks = true;
                            }

                            //Show un-paid breaks column if any of the values is positive
                            if (clock.unpaid_breaks) {
                                section.cols.unpaidBreaks = true;
                            }

                            clock.variance =  clock.paid_time - (clock.scheduled || 0);
                            section.totals.variance += clock.variance;

                            if (clock.actual_clock.clock_in && clock.actual_clock.clock_out) {
                                clock.isTimeZoneChanged = checkTimeZoneOffsetDifference(clock.actual_clock.clock_in, clock.actual_clock.clock_out, activeBrand.timezoneName);
                            }

                            section.totals.net_shift_seconds += clock.net_shift_seconds;
                            section.totals.overtime += clock.overtime;
                            section.totals.shifts_overtime += clock.overtime_shift_weights || 0;
                            section.totals.hours_overtime += clock.overtime;
                            section.totals.paid_breaks += clock.paid_breaks;
                            section.totals.paid_time += clock.paid_time;
                            section.totals.unpaid_breaks += clock.unpaid_breaks;
                            section.totals.amount += clock.amount;
                            section.currency = currency;

                            section.cols.scheduled = !activeBrand.untimed_shift_enabled;

                            if (clock.scheduled) {
                                section.totals.scheduled += clock.scheduled;
                            }
                        });
                    });
                    section.canAddNewEntries = !isTimesheetLocked;

                    var brandUser = activeBrandUsers[section.employeeId];
                    if (startDate) {
                        var employeeActivePaytype = brandUser && TSUsersService.getUserActivePayType(brandUser.id, startDate, 'WEEKLY');
                        section.hasClosedPDS = weekPaysheetTypesInfo[employeeActivePaytype] && weekPaysheetTypesInfo[employeeActivePaytype].is_pds_closed;
                    }
                    section.totals.amount = (section.totals.amount / 100).toFixed(2);
                    section.totals.premium_pay = ((section.totals.right_to_rest_amount + section.totals.penalties_amount) / 100).toFixed(2);
                    section.totals.differentialPayAmount = (section.totals.differentialPayAmount / 100).toFixed(2);
                    //find columns count
                    section.colsCount = 0;
                    for (var i in section.cols) {
                        if (section.cols[i]) {
                            section.colsCount++;
                        }
                    }

                    clockViolationsList = clockViolationsList.concat(getClockViolationsCodes(section['cols']));
                });
            }

            clockViolationsList = _.uniq(clockViolationsList);

            return sections;
        };

        CTTimesheetService.getEffectivePaysheetTypesInfo = function () {
            return weekPaysheetTypesInfo;
        }

        CTTimesheetService.parsePaysheetStatusesPerType = function (paysheetTypesInfo, timesheetView, selectedDate) {
          paysheetStatusesPerType = {};
            for (var i in paysheetTypesInfo) {
                var paysheetTypeInfo = paysheetTypesInfo[i];
                for (var j in paysheetTypeInfo['paysheet_types']) {
                    var type = paysheetTypeInfo['paysheet_types'][j];
                    paysheetStatusesPerType[type] = paysheetStatusesPerType[type] || {paysheet_statuses: []};
                    paysheetStatusesPerType[type]['allow_paysheet_early_closure'] = paysheetTypeInfo['allow_paysheet_early_closure'];

                    if (paysheetStatusesPerType[type]['paysheet_statuses'] && paysheetStatusesPerType[type]['paysheet_statuses'].length) {
                        paysheetStatusesPerType[type]['paysheet_statuses'] = paysheetStatusesPerType[type]['paysheet_statuses'].concat(paysheetTypeInfo['paysheet_statuses']);
                    } else {
                        paysheetStatusesPerType[type]['paysheet_statuses'] = paysheetTypeInfo['paysheet_statuses'];
                    }
                }
            }

            prepareEffectivePaysheetTypesInfo(timesheetView, selectedDate);
        };
        CTTimesheetService.checkIfPDSClosed = function (paysheetsStatuses) {
            for (var i in paysheetsStatuses) {
                if (['CLOSED', 'SENT'].indexOf(paysheetsStatuses[i].status) === -1) {
                    return false;
                }
            }
            return true;
        };

        CTTimesheetService.getWeekPaysheetTypesInfo = ()=> {
            return weekPaysheetTypesInfo;
        };

        const prepareEffectivePaysheetTypesInfo = (timesheetView, selectedDate) => {
            weekPaysheetTypesInfo = {};
            for (var type in paysheetStatusesPerType) {
                var paysheetTypeInfo = paysheetStatusesPerType[type];
                var isPdsClosed;
                var paysheetStatuses = [];

                for (var t in paysheetTypeInfo['paysheet_statuses']) {
                    var paysheetStatusInfo = angular.copy(paysheetTypeInfo['paysheet_statuses'][t]);

                    var isPaysheetStatusIncluded = false;
                    if (timesheetView === "DAY") {
                        isPaysheetStatusIncluded = moment(paysheetStatusInfo['date'], 'YYYY-MM-DD').isSame(selectedDate['from_date'], 'day');
                    } else {
                        isPaysheetStatusIncluded = (
                            moment(paysheetStatusInfo['date'], 'YYYY-MM-DD').isSameOrAfter(selectedDate['from_date'], 'day') &&
                            moment(paysheetStatusInfo['date'], 'YYYY-MM-DD').isSameOrBefore(selectedDate['to_date'], 'day')
                        );
                    }
                    if (isPaysheetStatusIncluded) {
                        paysheetStatuses.push(paysheetStatusInfo);
                    }
                }
                isPdsClosed = CTTimesheetService.checkIfPDSClosed(paysheetStatuses);
                if (type === 'SALARIED' && paysheetTypeInfo['allow_paysheet_early_closure']) {
                    isPdsClosed = false;
                }
                weekPaysheetTypesInfo[type] = {
                    allow_paysheet_early_closure: paysheetTypeInfo['allow_paysheet_early_closure'],
                    paysheet_statuses: paysheetStatuses,
                    is_pds_closed: isPdsClosed
                };
            }
        };

        //Brand Open & Close time details
        CTTimesheetService.findBrandOpenAndCloseTime = function (brand, date) {
            var dayDate = moment(date);

            var brandBusinessDay = getSelectedBusinessDay(date, brand);

            var openTimeObj = convertSecondsToTime(brandBusinessDay.open_time);
            var openTime = dayDate.clone();
            openTime.set('hour', openTimeObj.hours);
            openTime.set('minute', openTimeObj.minutes);
            openTime.set('second', openTimeObj.seconds);
            openTime.set('millisecond', 0);

            var clostTimeObj = convertSecondsToTime(brandBusinessDay.close_time);
            var closeTime = dayDate.clone();
            closeTime.set('hour', clostTimeObj.hours);
            closeTime.set('minute', clostTimeObj.minutes);
            closeTime.set('second', clostTimeObj.seconds);

            if (closeTime.isBefore(openTime) || closeTime.isSame(openTime)) {
                closeTime.add(1, 'd');
            }

            return {
                openTime: openTime,
                closeTime: closeTime
            }
        };

        CTTimesheetService.checkIfClockGreaterThan24Hours = function (clock) {
            if (clock && clock.actual_clock && clock.actual_clock.clock_in && clock.actual_clock.clock_out) {
                var clockIn = moment(clock.actual_clock.clock_in, 'YYYY-MM-DDTHH:mm:ss');
                var clockOut = moment(clock.actual_clock.clock_out, 'YYYY-MM-DDTHH:mm:ss');
                var shiftDuration = moment.duration(moment(clockOut).diff(moment(clockIn))).asSeconds();
                return shiftDuration > 24 * 60 * 60;
            }

            return false;
        };

        //Get date time from time input based on brand business day configuration
        CTTimesheetService.findTiming = function (start, end, brandBusinessDay, originalClock) {
            if (!start || !end) {
                return {
                    startTime: null,
                    endTime: null
                };
            }
            var isGreaterThan24Hours = CTTimesheetService.checkIfClockGreaterThan24Hours(originalClock);

            var startMoment = moment(start, "HH:mm A");
            startMoment.set('year', brandBusinessDay.openTime.get('year'));
            startMoment.set('month', brandBusinessDay.openTime.get('month'));
            startMoment.set('date', brandBusinessDay.openTime.get('date'));
            startMoment.set('second', 0);
            startMoment.set('millisecond', 0);

            if (startMoment.isBefore(brandBusinessDay.openTime)) {
                startMoment.add(1, 'day');
            }

            var endMoment = moment(end, "HH:mm A");
            endMoment.set('year', startMoment.get('year'));
            endMoment.set('month', startMoment.get('month'));
            endMoment.set('date', startMoment.get('date'));
            endMoment.set('second', 0);
            endMoment.set('millisecond', 0);

            /**
             * check if end time is before start time, then it's in the next day
             */
            if (endMoment.isBefore(startMoment) || endMoment.isSame(startMoment) || isGreaterThan24Hours) {
                endMoment.add(1, 'd');
            }

            return {
                startTime: startMoment,
                endTime: endMoment
            };
        };

        //Update employer timesheet tips settings
        CTTimesheetService.updateEmployerTimesheetTipsSettings = function (settings) {
            CTTimesheetService.employerTimesheetTipsSettings = settings;
        };

        //set employer timesheet call_ins settings
        CTTimesheetService.updateCallInSettings = function (settings) {
            CTTimesheetService.callInSettings = settings || [];
        };

        CTTimesheetService.updateBreaksSettings = function (settings) {
            CTTimesheetService.breaksSettings = settings || {};
        };

        CTTimesheetService.updateBreakEnginesSettings = function (settings) {
            CTTimesheetService.breakEngines = settings || [];
        }

        //set employer timesheet split_shift_penalty settings
        CTTimesheetService.updateSplitShiftPenaltySettings = function (settings) {
            CTTimesheetService.splitShiftPenaltySettings = settings;
        };

        CTTimesheetService.setBreakWaiverOnFileSettings = (settings) => {
            CTTimesheetService.breakWaiverOnFileSettings = settings;
        };

        CTTimesheetService.updateClockTimeStatusReasonSettings = function (settings) {
            CTTimesheetService.clockTimeStatusReasonSettings = {
                personal_reason_mode : (settings && settings.personal_reason_mode) || CTTimesheetService.CLOCK_TIME_STATUS_PERSONAL_REASON_MODES.PERSONAL
            };
        };

        //set employer timesheet Attestation Flow settings
        CTTimesheetService.updateAttestationFlowSettings = function (settings) {
           var clockTimeStatusReasonTrackingSettings = settings || [];

            CTTimesheetService.clockTimeStatusReasonTrackingSettings = clockTimeStatusReasonTrackingSettings.sort(function (item1, item2) {
                return moment(item1.start_date).valueOf() > moment(item2.start_date).valueOf() ? -1 : 1;
            });
        };

        CTTimesheetService.getClockTimeStatusReasonTrackingMode = function (date) {
            var clockTimeStatusReasonTrackingMode = "IMPLICIT";

            for (var i in CTTimesheetService.clockTimeStatusReasonTrackingSettings) {
                var dateSetting = CTTimesheetService.clockTimeStatusReasonTrackingSettings[i];

                if (new Date(date).getTime() >= new Date(dateSetting.start_date).getTime()) {
                    clockTimeStatusReasonTrackingMode = dateSetting.clock_time_status_reason_tracking_mode;
                    break;
                }
            }

            return clockTimeStatusReasonTrackingMode;
        };

        CTTimesheetService.updateOvernightShiftSettings = function (overnightShiftSettings) {
            CTTimesheetService.overnightShiftSettings = overnightShiftSettings || [];
        };

        CTTimesheetService.updateEmployeeConsentFlowSetting = function (employeeConsentFlowEnabled) {
            CTTimesheetService.employeeConsentFlowEnabled = employeeConsentFlowEnabled;
        };

        CTTimesheetService.checkOvernightShiftsSettings = function (date) {
            for (var i in CTTimesheetService.overnightShiftSettings) {
                if (new Date(date).getTime() >= new Date(CTTimesheetService.overnightShiftSettings[i].start_date).getTime()) {
                    return CTTimesheetService.overnightShiftSettings[i].status === "ACTIVE";
                }
            }
        };

        //set employer timesheet break_penalties settings
        CTTimesheetService.updateBreakPenaltiesSettings = function (settings) {
            CTTimesheetService.breakPenaltiesSettings = (settings && settings.types) || [];
        };

        CTTimesheetService.getBreaksRulesSet = function (date) {
            var dateToCheck = moment(date);
            for (var i in CTTimesheetService.breakPenaltiesSettings) {
                if (CTTimesheetService.breakPenaltiesSettings[i]) {
                    if (dateToCheck.valueOf() >= moment(CTTimesheetService.breakPenaltiesSettings[i].start_date).valueOf()) {
                        return CTTimesheetService.breakPenaltiesSettings[i].type !== 'NONE' ? CTTimesheetService.breakPenaltiesSettings[i].type : null;
                    }
                }
            }
        };

        CTTimesheetService.isBreakWaiverOnFileSettingEnabled = () => {
            return CTTimesheetService.breakWaiverOnFileSettings.some(breakObj =>
                breakObj.break_category === "MEAL" && breakObj.status === "ENABLED"
            );
        };

        CTTimesheetService.getSplitShiftPenaltySettings = function (date) {
            for (var i in CTTimesheetService.splitShiftPenaltySettings) {
                if (CTTimesheetService.splitShiftPenaltySettings[i]) {
                    if (new Date(date).getTime() >= new Date(CTTimesheetService.splitShiftPenaltySettings[i].start_date).getTime()) {
                        return CTTimesheetService.splitShiftPenaltySettings[i].type !== 'NONE' ? CTTimesheetService.splitShiftPenaltySettings[i].type : null;
                    }
                }
            }
        };

        CTTimesheetService.getActiveCallInsSettings = function (settings, date) {
            for (var i in settings) {
                var callInSettings = settings[i];
                if (new Date(date).getTime() >= new Date(callInSettings.start_date).getTime()) {
                    return callInSettings.type ? callInSettings.type : 'NONE';
                }
            }
        }

        CTTimesheetService.getCallInsSettings = function (date) {
            return CTTimesheetService.getActiveCallInsSettings(CTTimesheetService.callInSettings, date);
        };

        CTTimesheetService.getEffectiveBreakEngine = function (date) {
            var breakEngines =  CTTimesheetService.breakEngines;
            for (var i in breakEngines) {
                var breakEngineItem = breakEngines[i];

                if (moment(date).valueOf() >= moment(breakEngineItem['start_date']).valueOf()) {
                    return breakEngineItem['mode'];
                }
            }
        }

        CTTimesheetService.checkBreakRules = function (date) {
            var breakSettings =  CTTimesheetService.breaksSettings['breaks'];
            for (var i in breakSettings) {
                var breakSettingsItem = breakSettings[i];

                if (moment(date).valueOf() >= moment(breakSettingsItem['start_date']).valueOf()) {
                    return breakSettingsItem.values && breakSettingsItem.values.length > 0 &&
                        breakSettingsItem.values.findIndex(function (value) {
                            return value.duration > 0;
                        }) > -1;
                }
            }
            return false;
        }

        CTTimesheetService.getLactationSettings = function (date) {
            var lactationBreakSettings = CTTimesheetService.breaksSettings['lactation'];
            for (var i in lactationBreakSettings) {
                var lactationBreakSetting = lactationBreakSettings[i];
                if (new Date(date).getTime() >= new Date(lactationBreakSetting.start_date).getTime()) {
                    return lactationBreakSetting;
                }
            }
        };

        CTTimesheetService.getEmployeeConsentFlowSetting = function () {
            return CTTimesheetService.employeeConsentFlowEnabled;
        };

        //Get date time from time input based on brand business day configuration
        CTTimesheetService.findBreakTime = function (start, end, clockTiming) {
            if (!start || !end) {
                return {
                    startTime: null,
                    endTime: null
                };
            }

            var startMoment = moment(start, "HH:mm A");
            startMoment.set('year', clockTiming.startTime.get('year'));
            startMoment.set('month', clockTiming.startTime.get('month'));
            startMoment.set('date', clockTiming.startTime.get('date'));
            startMoment.set('second', 0);
            startMoment.set('millisecond', 0);

            var endMoment = moment(end, "HH:mm A");
            endMoment.set('year', clockTiming.startTime.get('year'));
            endMoment.set('month', clockTiming.startTime.get('month'));
            endMoment.set('date', clockTiming.startTime.get('date'));
            endMoment.set('second', 0);
            endMoment.set('millisecond', 0);


            /***
             * how to build the datetiem object
             *
             * 1- if open & close time are in the same day then we will put the start & end time in the same date
             */

            //in case start time is before open time then put it in the next day...
            if (startMoment.isBefore(clockTiming.startTime)) {
                startMoment.add(1, 'd');
            }

            /**
             * 2 - check if end time is before start time, then it's in the next day
             */
            if (endMoment.isBefore(startMoment)) {
                endMoment.add(1, 'd');
            }

            return {
                startTime: startMoment,
                endTime: endMoment
            };
        };

        /**
         * History Parsing in timecards
         * @param entry
         */

        var getBreakDuration = function(entry){

            if (entry.meta) {
                if (["actual_clock.breaks", "actual_clock.breaks.start", "actual_clock.breaks.end", "actual_clock.breaks.status"].indexOf(entry.attribute) > -1) {
                    var duration = entry.meta.duration;

                    if (!duration && entry.meta.start_time && entry.meta.end_time) {
                        duration = (new Date(entry.meta.end_time) - new Date(entry.meta.start_time)) / 1000;
                    }

                    return Math.floor(duration / 60);
                }
            }

            return 0;
        }

        var getBreakCategory = function(categoryCode) {
            var breakCategory = '';
            switch (categoryCode) {
                case "MEAL":
                    breakCategory = $filter('translate')('meal');
                    break;
                case "ORDINARY":
                    breakCategory = $filter('translate')('rest');
                    break;
                case "LACTATION":
                    breakCategory = $filter('translate')('lactation break');
                    break;
            }
            return breakCategory;
        };

        CTTimesheetService.getPremiumFormattedChangeValue = function (value) {
            value = Math.abs(value);
            var hours = Math.floor(value / (60*60));
            var minuets =  Math.floor(value / (60)) - (hours * 60);
            var formattedChangeValue = "";
            if (hours) {
                formattedChangeValue += hours + " " + $filter("translate")("hours");
            }

            if (hours && minuets ) {
                formattedChangeValue += " " + $filter("translate")("and");
            }

            if (minuets) {
                formattedChangeValue += " " + minuets + " " + $filter("translate")("minutes");
            }

            return formattedChangeValue
        };

        CTTimesheetService.getClockTimeStatusPersonalReasonMode = function() {

             if (CTTimesheetService.clockTimeStatusReasonSettings['personal_reason_mode'] === CTTimesheetService.CLOCK_TIME_STATUS_PERSONAL_REASON_MODES.PERSONAL_MUTUALLY_AGREED) {
                return {
                    key: 'PERSONAL',
                    value: 'Personal Reason/ Mutual Agreement'
                }
            }
             else {
                 return {
                     key: 'PERSONAL',
                     value: 'Personal Reason'
                 };
             }
        };

        var isShortBreak = function (breakItem) {
            if (breakItem.meta.start_time && breakItem.meta.end_time) {
                breakItem.acual_duration = (new Date(breakItem.meta.end_time) - new Date(breakItem.meta.start_time)) / 1000;
            }

            return breakItem.acual_duration > 0 && breakItem.acual_duration < breakItem.meta.duration;
        };

        const getBreakOrder = (order) => {
            let breakOrder = '';
            switch (order) {
                case BREAKS_MEAL_ORDER.FIRST_MEAL:
                    breakOrder = $filter("translate")("first");
                    break;
                case BREAKS_MEAL_ORDER.SECOND_MEAL:
                    breakOrder = $filter("translate")("second");
                    break;
            }
            return breakOrder;
        }

        var isLateMealBreak = function (breakItem) {
            return (
               breakItem.meta.category === 'MEAL' &&
               breakItem.meta.time_status === 'LATE' &&
               !isShortBreak(breakItem)
            );
        };

        var isShortLateMealBreak = function (breakItem) {
            return (
                breakItem.meta.category === 'MEAL' &&
                breakItem.meta.time_status === 'LATE' &&
                isShortBreak(breakItem)
            );
        };

        CTTimesheetService.formatTimeCardBreaks = function (breaksList) {
            var formattedBreaks = [];
            for (var i in breaksList) {
                var entry = angular.copy(breaksList[i]);
                if (entry.start_time && entry.end_time) {
                    var splittedBreak = breaksList.find(function (br) {
                        return br.original_break_id === entry.id && (br.original_source === 'SPLITTED');
                    })
                    if (splittedBreak) {
                        entry.end_time = splittedBreak.end_time;
                    }
                    if (!entry.original_break_id) {
                        formattedBreaks.push(entry);
                    }
                }
                else {
                    formattedBreaks.push(entry);
                }
            }
            return formattedBreaks;
        }

        CTTimesheetService.isValidBreakActionReason = (value) => {
            return (
                value &&
                value !== BREAK_ATTESTATION_REASONS.NONE.code
            )
        }

        CTTimesheetService.parseBreakAttestationTimeStatus = (timeStatus, isShortBreak, isBreakInAction) => {
            let breakTimeStatus;
            if (isBreakInAction && timeStatus === BREAK_TIME_STATUSES.LATE.code) {
                breakTimeStatus = BREAK_TIME_STATUSES.LATE.label;
            } else if (
                !isBreakInAction &&
                isShortBreak
            ) {
                breakTimeStatus = BREAK_TIME_STATUSES.SHORT.label;
            }
            return breakTimeStatus;
        }

        const parseBreakActionReasonMessage = (entry, action, breakTimeStatus, isBreakInAction) => {
            const formattedStartTime = $filter("formatDateIgnoreTimeZone")(entry.meta.start_time, "hh:mm A");
            const formattedEndTime = $filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A");
            const actualDuration = CTTimesheetService.getDurationInSeconds(formattedStartTime, formattedEndTime);
            const breakReason = action === ENTRY_ACTIONS.ADD ? entry.to : entry.from;

            const msgParts = [
                breakTimeStatus,
                BREAK_CATEGORIES[entry.meta.category].title,
                $filter("translate")('break')
            ]

            if (isBreakInAction && action === ENTRY_ACTIONS.ADD) {
                msgParts.push(`${$filter("translate")('started at')} ${formattedStartTime}`);
            } else if (formattedStartTime && formattedEndTime) {
                msgParts.push(
                    `${$filter("translate")('taken from')} ${formattedStartTime} ${$filter("translate")('to')} ${formattedEndTime}`,
                    breakTimeStatus === BREAK_TIME_STATUSES.SHORT.label ? `(${Math.floor(actualDuration / 60)} out of ${Math.floor(entry.meta.duration / 60)} minutes)` : '',
                )
            } else {
                msgParts.push(`${$filter("translate")('attestation captured from Teamhub')}`);
            }

            msgParts.push(
                `${$filter("translate")('was due to')}`,
                breakReason === BREAK_ATTESTATION_REASONS.PERSONAL.code
                    ? $filter("translate")('personal reasons')
                    : $filter("translate")('manager request'),
                action === ENTRY_ACTIONS.UPDATE ? $filter("translate")('and is not valid under the latest timecard changes') : ''
            )

            return msgParts.join(' ')
        }

        CTTimesheetService.timeToDuration = (time, unit) => {
            unit = unit || 'seconds';
            const timeMoment = moment(time, 'hh:mm a');
            const totalDuration = moment.duration(timeMoment.diff(moment().startOf('day')));

            if (unit === 'seconds') {
                return totalDuration.asSeconds();
            } else if (unit === 'minutes') {
                return totalDuration.asMinutes();
            }
            return 0;
        };

        CTTimesheetService.getDurationInSeconds = (startTime, endTime) => {
            if (startTime && endTime) {
                const startSeconds = CTTimesheetService.timeToDuration(startTime, 'seconds');
                let endSeconds = CTTimesheetService.timeToDuration(endTime, 'seconds');

                if (endSeconds < startSeconds) {
                    endSeconds += DAY_IN_SECONDS;
                }

                return endSeconds - startSeconds;
            }
            return 0;
        };

        const parseHistoryBreakActionText = (entry, breaksRulesSet) => {
            let actionText;
            if ([BREAK_STATUSES.PENALTY_EMPLOYER_ADDED,BREAK_STATUSES.PENALTY_AUTOMATICALLY_ADDED].includes(entry.meta.status)) {
                actionText = breaksRulesSet ? $filter("translate")('a premium owed') : $filter("translate")('a premium is confirmed');
            } else {
                actionText = $filter("translate")('no premium owed');
            }
            return `${actionText} ${$filter("translate")('for the ')}`;
        }

        CTTimesheetService.parseTimeCardHistoryEntry = function (entry, breaksRulesSet, clockTimeStatusReasonTrackingMode, isScheduledShift, entrySource) {

            var defer = $q.defer();

            var breakDuration = getBreakDuration(entry);
            var breakCategory = entry.meta && entry.meta.category ? getBreakCategory(entry.meta.category) : '';
            var isActionTakenBySystem =  entry.meta && entry.meta['break_in_action'] && entry.meta['break_in_action']['source'] === 'SYSTEM';
            let jobTitleItem;
            if (entry.meta?.job_title_lookup_id) {
                jobTitleItem = jobTitlesDataService.brandJobTitles[entry.meta.job_title_lookup_id];
            }

            let msg = "";
            let breakAttestationTimeStatus;

            switch (entry.attribute) {
                case "actual_clock.penalties":
                case "actual_clock.penalties.status":
                case "actual_clock.penalties.ignore_reason_id":
                    if (entry.action === "ADD" || entry.action === "UPDATE") {
                        var penalty = entry.meta;

                        if (penalty.status !== "PENDING_APPROVAL") {
                            var promises = {
                                'rules': fairSchedulingService.getPenaltiesRules()
                            };

                            if (penalty.status === 'IGNORED' || penalty.status === 'SYSTEM_IGNORED') {
                                promises['ignore_reasons'] = TimesheetSettingsService.getPremiumPayIgnoreReasons();
                            }

                            $q.all(promises)
                                .then(function (res) {
                                    var rule = res['rules'].find(function (item) {
                                        return item.id === penalty.rule_id;
                                    });

                                    if (rule) {
                                        penalty.ruleDetails = rule;
                                        penalty.penaltyDetails = fairSchedulingService.getPenaltyDetails(penalty, rule);

                                        if (entry.attribute === "actual_clock.penalties.ignore_reason_id" && penalty.status === 'APPROVED') {
                                            defer.resolve(msg);
                                        }


                                        if (penalty.status === 'APPROVED') {
                                            msg += $filter('translate')('Approved paying');
                                        } else if (penalty.status === 'IGNORED') {
                                            if (entry.from === 'APPROVED' || entry.from === "PENDING_APPROVAL") {
                                                msg += $filter('translate')('Resolved');
                                            } else {
                                                var fromReason = (res['ignore_reasons'].error_reasons).find(function (item) {
                                                    return item.id === entry.from;
                                                });
                                                var toReason = (res['ignore_reasons'].error_reasons).find(function (item) {
                                                    return item.id === entry.to;
                                                });
                                                msg += $filter('translate')('Updated resolved premium exception') + ' '
                                                    + $filter('translate')('from') + ' "' + $filter('translate')(fromReason.name) + '" - '
                                                    + $filter('translate')('to') + ' "' + $filter('translate')(toReason.name) + '"';
                                                defer.resolve(msg);
                                            }
                                        } else if (penalty.status === 'SYSTEM_IGNORED') {
                                            msg += $filter('translate')('System auto resolved');
                                        }

                                        var penaltyText;

                                        if (isScheduledShift) {
                                            if (penalty.source === "FORECAST") {
                                                penaltyText = $filter('translate')('schedule change premium');
                                            } else {
                                                penaltyText = $filter('translate')('actual change premium');
                                            }

                                            msg += " " + penaltyText;

                                            if (penalty.penaltyDetails.type === 'LENGTH_INCREMENT') {
                                                msg += " " + $filter('translate')('for adding');
                                            } else if (penalty.penaltyDetails.type === 'LENGTH_DECREMENT') {
                                                msg += " " + $filter('translate')('for subtracting');
                                            }

                                            if (penalty.penaltyDetails.type === 'LENGTH_DECREMENT' || penalty.penaltyDetails.type === 'LENGTH_INCREMENT') {
                                                msg += " " + CTTimesheetService.getPremiumFormattedChangeValue(penalty.penaltyDetails.change_value);
                                            }

                                            if (penalty.penaltyDetails.type === 'DATE_TIME_CHANGE') {
                                                msg += " " + $filter('translate')('for changing shift times');
                                            }
                                        } else {
                                            penaltyText = $filter('translate')('premium');

                                            msg += " " + penaltyText;
                                            msg += " " + $filter('translate')('for working an additional unscheduled shift of');
                                            msg += " " + CTTimesheetService.getPremiumFormattedChangeValue(penalty.penaltyDetails.change_value);
                                        }

                                        msg += " " + $filter('translate')('within notice period of') + " " + penalty.ruleDetails.shift_penalty_change_threshold_value + " ";
                                        if (penalty.ruleDetails.shift_penalty_change_threshold_type === 'DAY') {
                                            msg += $filter('translate')('days');
                                        } else {
                                            msg += $filter('translate')('hours');
                                        }

                                        if (penalty.status === 'IGNORED' || penalty.status === 'SYSTEM_IGNORED') {
                                            var reason = (res['ignore_reasons'].error_reasons).find(function (item) {
                                                return item.id === penalty.ignore_reason.id;
                                            });
                                            msg += " " + $filter('translate')('as an exception of') + ": " + $filter('translate')(reason.name);
                                        }
                                        defer.resolve(msg);
                                    } else {
                                        console.error("can't find rule", penalty.rule_id);
                                    }
                                });
                            return defer.promise;
                        }
                    }
                    break;

                case "actual_clock.right_to_rest":
                case "actual_clock.right_to_rest.status":
                case "actual_clock.right_to_rest.duration":
                case "actual_clock.right_to_rest.ignore_reason_id":
                    if (entry.action === "UPDATE") {
                        var penalty = entry.meta;
                        var rtrId = entry.meta.id;

                        if (penalty.status !== "PENDING_APPROVAL") {
                            var promises = {
                                'rules': fairSchedulingService.getPenaltiesRules(),
                                'clock_right_to_rest_audit' : CTTimesheetService.getClockRightToRestAudit(activeBrand.id, penalty.employee_id, rtrId, penalty.clock_id, penalty.shift_id, penalty.source === 'FORECAST')
                            };

                            if (penalty.status === 'IGNORED') {
                                promises['ignore_reasons'] = TimesheetSettingsService.getPremiumPayIgnoreReasons();
                            }

                            $q.all(promises)
                                .then(function (res) {
                                    var rule = res['rules'].find(function (item) {
                                        return item.id === penalty.rule_id;
                                    });

                                    if (rule) {
                                        penalty.ruleDetails = rule;
                                        penalty.penaltyDetails = fairSchedulingService.getPenaltyDetails(penalty, rule);

                                        if (entry.attribute === "actual_clock.right_to_rest.ignore_reason_id" && penalty.status === 'APPROVED') {
                                            defer.resolve(msg);
                                        }

                                        if (penalty.status === 'APPROVED') {
                                            msg += $filter('translate')('Approved');
                                        } else if (penalty.status === 'IGNORED') {
                                            msg += $filter('translate')('Resolved');
                                        } else if (penalty.status === 'SYSTEM_IGNORED') {
                                            msg += $filter('translate')('System auto resolved');
                                        }

                                        msg += " " + $filter('translate')('premium for breaking employee’s right to rest period by');

                                        msg += " " + CTTimesheetService.getPremiumFormattedChangeValue(penalty.penaltyDetails.change_value);

                                        if (res['clock_right_to_rest_audit'] && res['clock_right_to_rest_audit'].clock_source) {
                                            var brandName = res['clock_right_to_rest_audit'].clock_source.brand.name;
                                            msg += " " + "with a shift worked on a location" + " " +  brandName;
                                        }

                                        if (penalty.status === 'IGNORED') {
                                            var reason = (res['ignore_reasons'].error_reasons).find(function (item) {
                                                return item.id === penalty.ignore_reason.id;
                                            });
                                            msg += $filter('translate')('as') + " " + $filter('translate')(reason.name);
                                        } else if (penalty.status === 'SYSTEM_IGNORED') {
                                            msg += $filter('translate')('as exception due to having a non-hourly pay type or an inapplicable hourly rate during this period');
                                        }

                                        defer.resolve(msg);
                                    } else {
                                        console.error("can't find rule", penalty.rule_id);
                                    }
                                });
                            return defer.promise;
                        }
                    }
                    break;
                case "actual_clock":

                    if (entry.action === 'ADD') {
                        switch (entry.type) {
                            case 'SICK_LEAVE':
                                msg = $filter('translate')('resolved missed shift as sick');
                                break;

                            case 'NO_SHOW':
                                if (entry.error_reason) {
                                    TimesheetSettingsService.getTimesheetErrorsFlatList().then(function (res) {
                                        var reason = res.find(function(item){
                                            return item.id === entry.error_reason.id;
                                        })
                                        msg = $filter('translate')('resolved missed shift as') + " " + reason.name;
                                        defer.resolve(msg);
                                    });
                                    return defer.promise;
                                } else {
                                    msg = $filter('translate')('resolved missed shift as no show')
                                }
                                break;

                            case 'NO_SHOW_MANAGER_REQUEST':
                                msg = $filter('translate')('resolved missed shift as by manager request');
                                break;

                            case 'NO':
                                msg = $filter('translate')('resolved missed shift as no');
                                break;

                            default:
                                if (entry.meta.type === 'EMPLOYER_ADDED' && entry.meta.shift_id && entrySource !== 'REMOTE_CLOCK') {
                                    msg = $filter('translate')('resolved missed shift as no');
                                } else {
                                    msg = $filter("translate")("created a new time card");
                                }
                        }
                    }

                    break;
                case "actual_clock.status":
                    if (entry.action == "UPDATE") {

                        switch (entry.to) {
                            case 'DELETED':
                                msg= $filter("translate")("archived time card");
                                break;

                            case 'APPROVED':
                                msg= $filter("translate")("approved time card");
                                break;
                        }
                    }
                    break;
                    case "actual_clock.split_shift_penalty.status":
                        switch (entry.to) {
                            case 'EXCLUDED':
                                msg= $filter("translate")("disabled split-shift working hours");
                                break;

                            case 'INCLUDED':
                                msg= $filter("translate")("enabled split-shift working hours");
                                break;
                        }
                    break;

                case "actual_clock.clock_in":
                    if (entry.action === 'ADD') {
                        if (entry.type === 'OFFLINE-SYNC' || entry.type === 'OFFLINE-CONFLICT-RESOLVER') {
                            msg = $filter("translate")("added actual clock in time") + " " + $filter("formatDateIgnoreTimeZone")(entry.to, "hh:mm A") + ' ' + $filter('translate')('through the offline conflict resolution') + ".";
                        } else {
                            msg = $filter("translate")("added actual clock in time") + " " + $filter("formatDateIgnoreTimeZone")(entry.to, "hh:mm A");
                        }
                    } else if (entry.action == "UPDATE") {
                        var from = $filter("formatDateIgnoreTimeZone")(entry.from, "hh:mm A") || '-';
                        msg= $filter("translate")("Modified shift start time from") + " " + from
                                + " " + $filter("translate")("to") + " " + $filter("formatDateIgnoreTimeZone")(entry.to, "hh:mm A") + ".";
                    }
                    break;
                case "actual_clock.clock_out":
                    if (entry.action === 'ADD') {
                        if (entry.type === 'OFFLINE-SYNC' || entry.type === 'OFFLINE-CONFLICT-RESOLVER') {
                            msg = $filter("translate")("added actual clock out time") + " " + $filter("formatDateIgnoreTimeZone")(entry.to, "hh:mm A") + ' ' + $filter('translate')('through the offline conflict resolution') + ".";
                        } else {
                            msg = $filter("translate")("added actual clock out time") + ' ' + $filter("formatDateIgnoreTimeZone")(entry.to, "hh:mm A");
                        }
                    } else if (entry.action == "UPDATE") {
                        var from = $filter("formatDateIgnoreTimeZone")(entry.from, "hh:mm A") || '-';
                        msg= $filter("translate")("modified shift end time from") + " " + from
                                + " " + $filter("translate")("to")+ " " + $filter("formatDateIgnoreTimeZone")(entry.to, "hh:mm A") + ".";
                    }
                    break;
                case "actual_clock.position":
                    if (entry.action == "UPDATE") {
                        msg= $filter("translate")("modified position from") + " " + entry.from + " " + $filter("translate")("to") + " " + entry.to;
                    }
                    break;
                case "actual_clock.breaks":
                    if (entry.action == "ADD") {
                        if (entry.meta) {
                            if (
                                (
                                    ['EMPLOYEE_IGNORED', 'UNCONSUMED', 'INVOLUNTARILY_UNCONSUMED'].includes(entry.meta.status) &&
                                    entrySource === 'TEAMHUB'
                                ) ||
                                entry.meta.waive_status
                            ) {
                                let voluntarilyStatus = $filter("translate")("voluntarily");
                                if (entry.meta.waive_status === 'UNWAIVED') {
                                    voluntarilyStatus = $filter("translate")("involuntarily")
                                }
                                msg = [
                                    $filter("translate")("Employee"),
                                    voluntarilyStatus,
                                    (breaksRulesSet === 'CA' && entry.meta.category === 'ORDINARY' && entry.meta.waive_status !== 'UNWAIVED') ? $filter("translate")("declined a") : $filter("translate")("missed a"),
                                    breakDuration,
                                    $filter("translate")("minutes"),
                                    breakCategory,
                                    $filter("translate")("break")
                                ].join(" ");
                            } else if (['AUTOMATICALLY_IGNORED_BY_WAIVER_ON_FILE', 'IGNORED_BY_WAIVER_ON_FILE'].indexOf(entry.meta.status) > -1) {
                                msg = [
                                    $filter("translate")("Waived a"),
                                    breakDuration,
                                    $filter("translate")("minutes"),
                                    getBreakOrder(entry.meta.label),
                                    $filter("translate")(breakCategory),
                                    $filter("translate")("break") +  ':',
                                    $filter("translate")("waiver on file")
                                ].join(" ");
                            }
                            else {
                                var isBreakShort = breaksRulesSet && isShortBreak(entry);
                                var isLateBreak = breaksRulesSet && isLateMealBreak(entry)
                                var isShortLateBreak = breaksRulesSet && isShortLateMealBreak(entry);
                                var isShortOrLateBreak = isBreakShort || isLateBreak || isShortLateBreak;

                                if (
                                    entry.meta.status === BREAK_STATUSES.PENALTY_AUTOMATICALLY_ADDED ||
                                    (
                                        isShortOrLateBreak && 
                                        [BREAK_STATUSES.PENALTY_EMPLOYER_ADDED, BREAK_STATUSES.EMPLOYER_CONSUMED].includes(entry.meta.status)
                                    )
                                ) {
                                    msg = parseHistoryBreakActionText(entry, breaksRulesSet);
                                    if (isBreakShort || isShortLateBreak) {
                                        msg += $filter("translate")('short ')
                                    }
                                    if ((isLateBreak || isShortLateBreak) && breaksRulesSet !== BREAK_PENALTY_TYPES.WA) {
                                        msg += $filter("translate")('late ')
                                    }
                                    msg += [
                                        $filter("translate")(breakCategory) + " " + $filter("translate")("break"),
                                        $filter("formatDateIgnoreTimeZone")(entry.meta.start_time, "hh:mm A"),
                                        " - ",
                                        $filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A"),
                                        ",",
                                        `${Math.floor(entry.meta.duration / 60)} ${$filter("translate")("minutes")}`,
                                        entry.meta.status === 'PENALTY_EMPLOYER_ADDED' ? '(manager request)' : '',
                                    ].join(" ");
                                }
                                else {
                                    if (isActionTakenBySystem &&
                                        ['AUTOMATIC_ADD_TO_PAID_TIME', 'CONSUMED', 'AUTOMATICALLY_IGNORED'].indexOf(entry.meta.status) > -1) {
                                        msg = getAutoResolvedBreakMsg(entry);
                                    }
                                    else {
                                        msg = [
                                            $filter("translate")("added a new"),
                                            breakDuration,
                                            $filter("translate")("minutes"),
                                            breakCategory,
                                            $filter("translate")("break")
                                        ];
                                        if (entry.meta.start_time && entry.meta.end_time) {
                                            msg.push($filter("translate")("from"),
                                                $filter("formatDateIgnoreTimeZone")(entry.meta.start_time, "hh:mm A"),
                                                $filter("translate")("to"), $filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A"));
                                        }
                                        msg = msg.join(" ");

                                        if (entry.type === 'OFFLINE-SYNC' || entry.type === 'OFFLINE-CONFLICT-RESOLVER') {
                                            msg += ' ' + $filter('translate')('through the offline conflict resolution') + ".";
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (entry.action == "DELETE") {
                        if (entry.meta.start_time && entry.meta.end_time) {
                            msg= $filter("translate")("removed") + " " + breakDuration + " " + $filter("translate")("minutes") + " " + breakCategory + " " + $filter("translate")("break from") + " " + $filter("formatDateIgnoreTimeZone")(entry.meta.start_time, "hh:mm A")
                                + " " + $filter("translate")("to") + " " + $filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A");
                        } else {
                            msg= $filter("translate")("removed missed") + " " + breakDuration + " " + $filter("translate")("minutes") + " " + breakCategory + " " + $filter("translate")("break from allowed breaks");
                        }
                    }
                    break;
                case "actual_clock.breaks.category":
                    if (entry.action == "UPDATE") {
                        msg = $filter("translate")('Modified the') + ' ' + $filter("formatDateIgnoreTimeZone")(entry.meta.start_time, "hh:mm A") + " " +  '-' + " " + $filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A") + " " +
                             $filter("translate")("break type from")  + " " + getBreakCategory(entry.from) + " " + $filter("translate")("to") + " " + getBreakCategory(entry.to);
                    }
                    break;
                case "actual_clock.breaks.type":
                    if (entry.action === "REMOVED_FROM_ALLOWED") {
                        msg= $filter("translate")("removed") + " " + breakCategory + " " + $filter("translate")("break from") + " " + $filter("formatDateIgnoreTimeZone")(entry.meta.start_time, "hh:mm A")
                            + " " + $filter("translate")("to") + " " + $filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A") + " " + $filter('translate')("from allowed breaks");
                    } else if (entry.action === "ADDED_TO_ADDITIONAL") {
                        msg = $filter("translate")("added") + " " + breakCategory + " " + $filter("translate")("break from") + " " + $filter("formatDateIgnoreTimeZone")(entry.meta.start_time, "hh:mm A")
                            + " " + $filter("translate")("to") + " " + $filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A") + " " + $filter('translate')("to additional breaks");
                    } else if (entry.action ===  'BREAK_TYPE_CHANGED') {
                        msg = $filter("translate")('Modified the') + ' ' + $filter("formatDateIgnoreTimeZone")(entry.meta.start_time, "hh:mm A") + " " +  '-' + " " + $filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A") + " " +
                            $filter("translate")("break type from")  + " " + (entry.from === "UNSCHEDULED_PAID" ? 'paid' : 'unpaid') + " " + $filter("translate")("to") + " " + (entry.to === "UNSCHEDULED_PAID" ? 'paid' : 'unpaid');
                    }
                    break;
                case ENTRY_ATTRIBUTES.BREAKS_STATUS:
                    var isBreakShort = breaksRulesSet && isShortBreak(entry);
                    var isLateBreak = breaksRulesSet && isLateMealBreak(entry)
                    var isShortLateBreak = breaksRulesSet && isShortLateMealBreak(entry);
                    var isShortOrLateBreak = isBreakShort || isLateBreak || isShortLateBreak;
                    var IsBreakRulesApplied = breaksRulesSet && (entry.meta.category === 'MEAL' || (entry.meta.category == 'ORDINARY' && entry.meta.type === 'PAID'))

                    if (
                        entry.action === ENTRY_ACTIONS.UPDATE &&
                        entry.from !== BREAK_STATUSES.RUNNING &&
                        !breaksHistoryFactory.isAutomaticallyEmployeeConfirmDuePersonalReason(entry)
                    ) {
                        var breakDuration = Math.floor(entry.meta.duration / 60) + " " + $filter("translate")("minutes");

                        if (
                            [
                                BREAK_STATUSES.LATE_CONSUMED,
                                BREAK_STATUSES.SHORT_CONSUMED,
                                BREAK_STATUSES.SHORT_LATE_CONSUMED
                            ].includes(entry.from)
                        ) {
                            const premuimText = entry.to === BREAK_STATUSES.EMPLOYER_CONSUMED ? $filter("translate")('No premium owed') : $filter("translate")('A premium owed');
                            var resolveStatusType = premuimText + ' ' + $filter("translate")("for the late");
                            var breakCategory = entry.meta.category === "MEAL" ? 'meal' : 'rest';

                            if (entry.from === "SHORT_CONSUMED") {
                                resolveStatusType = premuimText + ' ' + $filter("translate")("for the short");
                            } else if (entry.from === "SHORT_LATE_CONSUMED") {
                                resolveStatusType = premuimText + ' ' + $filter("translate")("for the short and late");
                            }

                            msg = [
                                resolveStatusType,
                                $filter("translate")(breakCategory) +" "+ $filter("translate")("break"),
                                $filter("formatDateIgnoreTimeZone")(entry.meta.start_time, "hh:mm A"),
                                " - ",
                                $filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A"),
                                ",",
                                breakDuration,
                                [
                                    BREAK_STATUSES.PENALTY_EMPLOYER_ADDED,
                                    BREAK_STATUSES.PENALTY_AUTOMATICALLY_ADDED
                                ].includes(entry.to) ? $filter("translate")("as manager request") : '',
                            ].join(" ");
                        } else if (breaksRulesSet && entry.from === "INVOLUNTARILY_UNCONSUMED" && isShortBreak(entry)) {
                            var breakCategory = entry.meta.category === "MEAL" ? 'meal' : 'rest';

                            msg = [
                                $filter("translate")("no premium owed for the short"),
                                $filter("translate")(breakCategory),
                                $filter("translate")("break"),
                                $filter("formatDateIgnoreTimeZone")(entry.meta.start_time, "hh:mm A"),
                                " - ",
                                $filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A"),
                                ",",
                                breakDuration,
                                $filter("translate")("as"),
                                entry.to === 'PENALTY_EMPLOYER_ADDED' ? '(manager request)': '',
                            ].join(" ");

                        } else {
                            if (isActionTakenBySystem &&
                                ['AUTOMATIC_ADD_TO_PAID_TIME', 'CONSUMED', 'AUTOMATICALLY_IGNORED'].indexOf(entry.to) > -1) {
                                msg = getAutoResolvedBreakMsg(entry);
                            }
                            else if (['AUTOMATICALLY_IGNORED_BY_WAIVER_ON_FILE', 'IGNORED_BY_WAIVER_ON_FILE'].indexOf(entry.to) > -1) {
                                msg = [
                                    $filter("translate")("Waived a"),
                                    breakDuration,
                                    getBreakOrder(entry.meta.label),
                                    $filter("translate")(breakCategory),
                                    $filter("translate")("break") +   ':',
                                    $filter("translate")("waiver on file")
                                ].join(" ");
                            }
                            else {
                                if (entry.to === "EMPLOYER_ADDED" ||
                                    (entry.to === "AUTOMATIC_ADD_TO_PAID_TIME" && !isActionTakenBySystem)) {
                                    msg = [
                                        $filter("translate")("added"),
                                        breaksRulesSet ? $filter("translate")("the missed") : '',
                                        breakDuration,
                                        entry.meta.type === 'SPLIT_SHIFT' ? $filter("translate")("split shift") : breakCategory,
                                        $filter("translate")("break to pay time")
                                    ].join(" ");
                                }
                                else if (entry.to === "EMPLOYER_IGNORE" ||
                                        (entry.to === 'AUTOMATICALLY_IGNORED'&& !isActionTakenBySystem)) {
                                    if (IsBreakRulesApplied) {
                                        msg = [
                                            $filter("translate")("no premium owed for missed"),
                                            breakDuration,
                                            entry.meta.type === 'SPLIT_SHIFT' ? $filter("translate")("split shift") : breakCategory,
                                            $filter("translate")("break")
                                        ].join(" ");
                                    }
                                    else {
                                        msg = [
                                            $filter("translate")("dismissed a"),
                                            breakDuration,
                                            breakCategory,
                                            $filter("translate")("break")
                                        ].join(" ");
                                    }

                                }
                                else if (
                                    [
                                        BREAK_STATUSES.EMPLOYER_CONSUMED, 
                                        BREAK_STATUSES.PENALTY_EMPLOYER_ADDED, 
                                        BREAK_STATUSES.PENALTY_AUTOMATICALLY_ADDED
                                    ].includes(entry.to)
                                ) {
                                    if (isShortOrLateBreak) {
                                        var breakDuration = Math.floor(entry.meta.duration / 60) + " " + $filter("translate")("minutes");
                                        msg = parseHistoryBreakActionText(entry, breaksRulesSet);
                                        if (isBreakShort || isShortLateBreak) {
                                            msg += $filter("translate")('short ')
                                        }
                                        if ((isLateBreak || isShortLateBreak) && breaksRulesSet !== BREAK_PENALTY_TYPES.WA) {
                                            msg += $filter("translate")('late ')
                                        }
                                        msg += [
                                            $filter("translate")(breakCategory) +" "+ $filter("translate")("break"),
                                            $filter("formatDateIgnoreTimeZone")(entry.meta.start_time, "hh:mm A"),
                                            " - ",
                                            $filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A"),
                                            ",",
                                            breakDuration,
                                            entry.to === 'PENALTY_EMPLOYER_ADDED' ? '(manager request)': '',
                                        ].join(" ");
                                    } else {
                                        if (entry.to === "EMPLOYER_CONSUMED") {
                                            msg = [
                                                $filter("translate")("added"),
                                                breakCategory,
                                                $filter("translate")("break"),
                                                $filter("formatDateIgnoreTimeZone")(entry.meta.start_time, "hh:mm A"),
                                                "to",
                                                $filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A"),
                                            ].join(" ");
                                        }
                                        else {
                                            msg = [
                                                breaksRulesSet ? $filter("translate")('A premium owed for') : $filter("translate")('A premium is confirmed for'),
                                                $filter("translate")("missed"),
                                                breakDuration,
                                                entry.meta.type === 'SPLIT_SHIFT' ? $filter("translate")("split shift") : breakCategory,
                                                $filter("translate")("break")
                                            ].join(" ");
                                        }
                                    }
                                }
                            }
                        }
                    } else if (breaksHistoryFactory.isAutomaticallyEmployeeConfirmDuePersonalReason(entry)) {
                        const breakAttestationTimeStatus = CTTimesheetService.parseBreakAttestationTimeStatus(entry.meta.break_out_action?.time_status, isShortBreak(entry));
                        msg = [
                            $filter("translate")('No premium owed for the'),
                            breakAttestationTimeStatus === BREAK_TIME_STATUSES.SHORT.label ? $filter("translate")('short') : $filter("translate")('late'),
                            BREAK_CATEGORIES[entry.meta.category].title,
                            `${$filter("translate")('break')} [${$filter("formatDateIgnoreTimeZone")(entry.meta.start_time, "hh:mm A")} - ${$filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A")}],`,
                            `[${Math.floor(entry.meta.duration / 60)} ${$filter("translate")('minutes')}].`,
                            $filter('translate')('Due: Personal reasons confirmed on Teamhub'),
                        ].join(" ")
                    }
                    break;
                case "actual_clock.breaks.status_reason":
                    if (entry.action === 'ADD' && entry.to === 'PERSONAL') {
                        msg = $filter('translate')('due')+ ': ' + $filter('translate')('Personal reasons agreed upon between the employee and manager')+'.';
                    }
                    break;
                case "actual_clock.breaks.start":
                    if (entry.action == "ADD" && entry.meta) {
                        msg= $filter("translate")("added a new") + " " + breakDuration + " " + $filter("translate")("minutes") + " " + breakCategory;
                        if (entry.meta.start_time && entry.meta.end_time) {
                            msg += " " + $filter("translate")("from") + " " + $filter("formatDateIgnoreTimeZone")(entry.meta.start_time, "hh:mm A")
                                + " " + $filter("translate")("to") + " " + $filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A");
                        }
                    } else if (entry.action == "UPDATE") {
                        msg = `${$filter("translate")("modified")} ${breakDuration} ${$filter("translate")("minutes")} ${breakCategory} ${$filter("translate")("start time from")} ${entry.from ? $filter("formatDateIgnoreTimeZone")(entry.from, "hh:mm A") : "null"} ${$filter("translate")("to")} ${$filter("formatDateIgnoreTimeZone")(entry.to, "hh:mm A")}`;
                    } else if (entry.action == "DELETE") {
                        msg = `${$filter("translate")("removed")} ${breakDuration} ${$filter("translate")("minutes")} ${breakCategory} ${$filter("translate")("break start time")}: ${$filter("formatDateIgnoreTimeZone")(entry.from, "hh:mm A")}`;
                    }
                    break;
                case "actual_clock.breaks.end":
                    if (entry.action == "ADD" && entry.meta) {
                        msg= $filter("translate")("modified the") + " " + breakDuration + " " + $filter("translate")("minutes") + " " + breakCategory + " " + $filter("translate")("end time from") + " - "
                            + $filter("translate")("to") + " " + $filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A") + ", " + $filter("translate")("break") + " (" + $filter("formatDateIgnoreTimeZone")(entry.meta.start_time, "hh:mm A") + " - " + $filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A") + ")";
                    } else if (entry.action == "UPDATE") {
                        msg = `${$filter("translate")("modified")} ${breakDuration} ${$filter("translate")("minutes")} ${breakCategory} ${$filter("translate")("end time from")} ${entry.from ? $filter("formatDateIgnoreTimeZone")(entry.from, "hh:mm A") : "null"} ${$filter("translate")("to")} ${$filter("formatDateIgnoreTimeZone")(entry.to, "hh:mm A")}`;
                    } else if (entry.action == "DELETE") {
                        msg = `${$filter("translate")("removed")} ${breakDuration} ${$filter("translate")("minutes")} ${breakCategory} ${$filter("translate")("break end time")}: ${$filter("formatDateIgnoreTimeZone")(entry.from, "hh:mm A")}`;
                    } else if (entry.action == "ENDED") {
                        msg= $filter("translate")("ended the") + " " + breakDuration + " " + $filter("translate")("minutes") + " " + breakCategory + " " + $filter("translate")("break") +
                             " (" + $filter("formatDateIgnoreTimeZone")(entry.meta.start_time, "hh:mm A") + " - " + $filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A") + ")";
                    }
                    break;
                case ENTRY_ATTRIBUTES.BREAK_IN_ACTION_REASON:
                    breakAttestationTimeStatus = CTTimesheetService.parseBreakAttestationTimeStatus(entry.meta.break_in_action?.time_status, isShortBreak(entry), true);
                    msg = parseBreakActionReasonMessage(entry, entry.action, breakAttestationTimeStatus, true);
                    break;
                case ENTRY_ATTRIBUTES.BREAK_OUT_ACTION_REASON:
                    breakAttestationTimeStatus = CTTimesheetService.parseBreakAttestationTimeStatus(entry.meta.break_out_action?.time_status, isShortBreak(entry));
                    msg = parseBreakActionReasonMessage(entry, entry.action, breakAttestationTimeStatus);
                    break;
                case "actual_clock.meals":
                    if (entry.action == "UPDATE") {
                        msg = $filter("translate")("changed meals taken from") + " " + entry.from + " " + $filter("translate")("to") + " " + entry.to;
                    } else if (entry.action == "ADD") {
                            msg= $filter("translate")("changed meals taken from") + " 0 " + $filter("translate")("to") + " " + entry.to;
                    }
                    break;
                case "actual_clock.tips":
                case "actual_clock.tips.amount":
                case "actual_clock.tips.business_day_part_1.amount":
                case "actual_clock.tips.business_day_part_2.amount":
                    var fromValue = entry.from;
                    var toValue =  entry.to;
                    var dayChangedText;

                    if (entry.attribute.indexOf('business_day_part_1') > -1) {
                        fromValue = entry.from && entry.from['business_day_part_1'] && entry.from['business_day_part_1']['amount'] || 0;
                        toValue = entry.to['business_day_part_1'] && entry.to['business_day_part_1']['amount'] || 0;
                        dayChangedText = 'for hours worked on first business day';
                    }

                    if (entry.attribute.indexOf('business_day_part_2') > -1) {
                        fromValue = entry.from && entry.from['business_day_part_2'] && entry.from['business_day_part_2']['amount'] || 0;
                        toValue = entry.to['business_day_part_2'] && entry.to['business_day_part_2']['amount'] || 0;
                        dayChangedText = 'for hours worked on Second business day';
                    }

                    if (!entry.type) {
                        if (entry.action === "UPDATE") {
                            msg = $filter("translate")("modified tips amount from") + " " + currency + parseFloat(fromValue / 100).toFixed(2) + " " + $filter("translate")("to") + " " + currency + parseFloat(toValue / 100).toFixed(2) ;
                        }else if (entry.action === "ADD"){
                            msg = $filter("translate")("modified tips amount from") + " " + currency + "0 " + $filter("translate")("to") + " " + currency + parseFloat(toValue / 100).toFixed(2);
                        }
                    }
                    else if (entry.type === "DISTRIBUTION") {
                        if (entry.action === "UPDATE") {
                            msg = $filter("translate")("distributed tips amount from") + " " + currency + parseFloat(fromValue / 100).toFixed(2) + " " + $filter("translate")("to") + " " + currency + parseFloat(toValue / 100).toFixed(2);
                        } else if (entry.action === "ADD"){
                            msg = $filter("translate")("distributed tips amount from") + " " + currency + "0 " + $filter("translate")("to") + " " + currency + parseFloat(toValue / 100).toFixed(2);
                        }
                    }
                    else if (entry.type === 'OFFLINE-SYNC' || entry.type === 'OFFLINE-CONFLICT-RESOLVER') {
                        msg = $filter("translate")("distributed tips, tip value set to ") + " " + parseFloat(entry.to / 100).toFixed(2) + ' ' + $filter('translate')('through the offline conflict resolution') + ".";
                    }

                    if (dayChangedText) {
                        msg += ' ' + $filter("translate")(dayChangedText);
                    }

                    break;
                case "actual_clock.sick_leave":
                    if (entry.action === "ADD" && !(!entry.from && entry.to === 0)) {
                        msg = $filter("translate")("has set sick hours to") + " " + parseFloat((entry.to / 60 / 60).toFixed(2));
                    } else if (entry.action === "UPDATE") {
                        msg = $filter("translate")("has changed sick hours from") + " " + parseFloat((entry.from / 60 / 60).toFixed(2)) + " " + $filter("translate")("to") + " " + parseFloat((entry.to / 60 / 60).toFixed(2));
                    }
                    break;

                case "actual_clock.call_in.status":
                    if ( ["PENDING_APPROVAL", "IGNORED"].indexOf(entry.from) > -1  && entry.to === "APPROVED") {
                        msg = $filter("translate")("Reporting time premium approved")
                    } else if (entry.to === "SYSTEM_APPROVED") {
                        msg = $filter("translate")("Reporting time premium auto-confirmed")
                    } else if (entry.to === "SYSTEM_IGNORED") {
                        msg = $filter("translate")("Reporting time premium auto-resolved")
                    }
                    break;
                case "actual_clock.call_in.duration":
                    msg = $filter("translate")("reporting time duration was affected and updated from ") + parseFloat((entry.from / 60 / 60).toFixed(2)) + " to " + parseFloat((entry.to / 60 / 60).toFixed(2));
                    break;
                case "actual_clock.call_in.ignore_reason_id":
                    TimesheetSettingsService.getCallInIgnoreReasons()
                        .then(function (ignoreReasons) {
                            if (entry.action === ENTRY_ACTIONS.ADD && entry.to) {
                                const fromReason = (ignoreReasons.error_reasons).find((item) => {
                                    return item.id === entry.to;
                                });
                                msg = $filter('translate')('Resolved reporting time premium  as an exception of') + ': '
                                    + $filter('translate')(fromReason.name);
                                defer.resolve(msg);
                            } else if (entry.action === ENTRY_ACTIONS.UPDATE && entry.from && entry.to) {
                                const fromReason = (ignoreReasons.error_reasons).find((item) => {
                                    return item.id === entry.from;
                                });
                                const toReason = (ignoreReasons.error_reasons).find((item) => {
                                    return item.id === entry.to;
                                });
                                msg = $filter('translate')('Updated resolved premium exception') + ' '
                                    + $filter('translate')('from') + ' "' + $filter('translate')(fromReason.name) + '" - '
                                    + $filter('translate')('to') + ' "' + $filter('translate')(toReason.name) + '"';
                                defer.resolve(msg);
                            } else {
                                console.warn("Unhandled case in call_in.ignore_reason_id", entry);
                                defer.resolve("");
                            }
                        })
                        .catch((error) => {
                            console.error("Error in call_in.ignore_reason_id", error);
                            defer.resolve("");
                        });
                    return defer.promise;
                case "actual_clock.clock_in_action.reason":
                case "actual_clock.clock_out_action.reason":
                    var reasons;
                    var personalReasonMode = CTTimesheetService.getClockTimeStatusPersonalReasonMode().value;

                    if (clockTimeStatusReasonTrackingMode === "EXPLICIT") {
                        reasons = {
                            "UNPAID_PERSONAL": personalReasonMode,
                            "PAID_PERSONAL": personalReasonMode,
                            "SICK_LEAVE": "Sick Leave",
                            "MANAGER_REQUEST": "Manager Instruction",
                            "NONE": "None"
                        };
                    } else {
                        reasons = {
                            "UNPAID_PERSONAL": "Unpaid" + ' ' + personalReasonMode,
                            "PAID_PERSONAL": personalReasonMode,
                            "SICK_LEAVE": "Sick Leave",
                            "MANAGER_REQUEST": "Employer Dismissal",
                            "NONE": "None"
                        };
                    }

                    var from, to;

                    if (!entry.from) {
                        from = "None"
                    } else {
                        from = reasons[entry.from];
                        from += entry.from_system || "";
                    }

                    if (!entry.to) {
                        to = "None"
                    } else {
                        to = reasons[entry.to];
                    }

                    if (from !== to) {
                        if (clockTimeStatusReasonTrackingMode === "EXPLICIT") {
                            if (entry.attribute === "actual_clock.clock_in_action.reason") {
                                if (from === "None") {
                                    msg = $filter("translate")("added clock in reason") + " " + to.toLowerCase();
                                } else {
                                    msg = $filter("translate")("modified clock in reason from") + " " + from.toLowerCase() + " " + $filter("translate")("to") + " " + to.toLowerCase();
                                }
                            } else {
                                if (from === "None") {
                                    msg = $filter("translate")("added clock out reason") + " " + to.toLowerCase();
                                } else {
                                    msg = $filter("translate")("modified clock out reason from") + " " + from.toLowerCase() + " " + $filter("translate")("to") + " "  + to.toLowerCase();
                                }
                            }
                        } else {
                            if (from === "None") {
                                switch (entry.attribute) {
                                    case "actual_clock.clock_in_action.reason":
                                        msg = $filter("translate")("added clock in reason");
                                        break;
                                    default:
                                        msg = $filter("translate")("added clock out reason");
                                }
                                msg += " " + to.toLowerCase();
                            } else {
                                switch (entry.attribute) {
                                    case "actual_clock.clock_in_action.reason":
                                        msg = $filter("translate")("modified clock in reason from");
                                        break;
                                    default:
                                        msg = $filter("translate")("modified clock out reason from");
                                }
                                msg += " " + from.toLowerCase() + " " + $filter("translate")("to") + " " + to.toLowerCase();
                            }
                        }
                    }

                    break;

                case "actual_clock.category":
                    var from = entry.from;
                    var to = entry.to;

                    var promises = {};

                    if (from === 'NO_SHOW' || to === 'NO_SHOW') {
                        promises['reasons'] = TimesheetSettingsService.getTimesheetErrorsFlatList(true);
                    }

                    $q.all(promises)
                        .then(function (result) {

                            var noShowText = $filter("translate")("no show");

                            if ((from === 'NO_SHOW' || to === 'NO_SHOW') && (entry.from_reason || entry.to_reason)) {
                                var errorReasons = result['reasons'] || [];
                                var reason = _.find(errorReasons, function (item) {
                                    if (to === 'NO_SHOW' && entry.to_reason) {
                                        return item.id === entry.to_reason;
                                    } else {
                                        return item.id === entry.from_reason;
                                    }
                                });

                                if (reason) {
                                    noShowText = reason.name;
                                }
                            }

                            if (!from) {
                                switch (to) {
                                    case 'SICK_LEAVE':
                                        msg = $filter('translate')('resolved missed shift error as sick');
                                        break;

                                    case 'NO_SHOW':
                                        msg = [
                                            $filter("translate")("resolved missed shift error as"),
                                            noShowText
                                        ].join(" ");
                                        break;

                                    case 'NO_SHOW_MANAGER_REQUEST':
                                        msg = $filter('translate')('resolved missed shift error as per employer request');
                                        break;
                                }
                            } else {

                                switch (to) {
                                    case 'SICK_LEAVE':
                                        switch (from) {
                                            case 'NO_SHOW':
                                                msg = [
                                                    $filter("translate")("updated missed shift resolution from"),
                                                    noShowText,
                                                    $filter("translate")("to"),
                                                    $filter("translate")("sick")
                                                ].join(" ");
                                                break;
                                            case 'NO_SHOW_MANAGER_REQUEST':
                                                msg = $filter('translate')('updated missed shift resolution from per employer request to sick');
                                                break;

                                            case 'ORDINARY':
                                                msg = $filter('translate')('resolved missed shift error as sick');
                                                break;
                                        }

                                        break;

                                    case 'NO_SHOW':
                                        switch (from) {
                                            case 'SICK_LEAVE':
                                                msg = [
                                                    $filter("translate")("updated missed shift resolution from sick to"),
                                                    noShowText,
                                                ].join(" ");
                                                break;
                                            case 'NO_SHOW_MANAGER_REQUEST':
                                                msg = [
                                                    $filter("translate")("updated missed shift resolution from per employer request to"),
                                                    noShowText
                                                ].join(" ");
                                                break;
                                            case 'ORDINARY':
                                                msg = [
                                                    $filter("translate")("resolved missed shift error as"),
                                                    noShowText
                                                ].join(" ");
                                                break;
                                        }
                                        break;

                                    case 'NO_SHOW_MANAGER_REQUEST':
                                        switch (from) {
                                            case 'SICK_LEAVE':
                                                msg = $filter('translate')('updated missed shift resolution from sick to per employer request');
                                                break;
                                            case 'NO_SHOW':
                                                msg = [
                                                    $filter("translate")("updated missed shift resolution from"),
                                                    noShowText,
                                                    $filter("translate")("to"),
                                                    $filter("translate")("per employer request")
                                                ].join(" ");
                                                break;

                                            case 'ORDINARY':
                                                msg = $filter('translate')('resolved missed shift error as per employer request');
                                                break;
                                        }
                                        break;

                                    case 'ORDINARY':
                                        switch (from) {
                                            case 'SICK_LEAVE':
                                                msg = $filter('translate')('resolved missed shift (Sick) by entering clock times');
                                                break;

                                            case 'NO_SHOW':
                                                msg = [
                                                    $filter("translate")("updated missed shift resolution from"),
                                                    noShowText,
                                                    $filter("translate")("by"),
                                                    $filter("translate")("entering clock times")
                                                ].join(" ");
                                                break;

                                            case 'NO_SHOW_MANAGER_REQUEST':
                                                msg = $filter('translate')('resolved missed shift (Per employer request) by entering clock times');
                                                break;

                                            case 'ORDINARY':
                                                msg = $filter('translate')('resolved missed shift error by entering clock times');
                                                break;
                                        }
                                        break;
                                }
                            }

                            defer.resolve(msg);
                        });
                    return defer.promise;

                case "actual_clock.error_reason.id":
                    TimesheetSettingsService.getTimesheetErrorsFlatList(true)
                        .then(function (error_reasons) {
                            var from = entry.from;
                            var to = entry.to;
                            var fromReason = '';
                            var toReason = '';

                            if (error_reasons.length) {
                                if (entry.from) {
                                    var reason = _.find(error_reasons, function (item) {
                                        return item.id === from;
                                    });

                                    fromReason = reason? reason.name: 'N/A';
                                }

                                if (entry.to) {
                                    var reason = _.find(error_reasons, function (item) {
                                        return item.id === to;
                                    });

                                    toReason = reason? reason.name: 'N/A';
                                }
                            }

                            if (from && to) {
                                msg = [
                                    $filter('translate')('updated missed shift resolution from'),
                                    fromReason,
                                    $filter('translate')('to'),
                                    toReason
                                ].join(" ");
                            } else if (!from && to) {
                                msg = [
                                    $filter('translate')('updated missed shift resolution from no show to'),
                                    toReason
                                ].join(" ");
                            } else {
                                msg = [
                                    $filter('translate')('updated missed shift resolution from'),
                                    fromReason,
                                    $filter('translate')('to no show')
                                ].join(" ");
                            }

                            defer.resolve(msg);
                        });
                    return defer.promise;

                case 'actual_clock.employee_status':
                    var from = entry.from;
                    var to = entry.to;

                    if (entry.action === 'ADD') {
                        switch (to) {
                            case 'EMPLOYEE_PROTESTED':
                                msg = $filter('translate')('disagreed on the latest approved timecard');
                                break;

                            case 'EMPLOYEE_APPROVED':
                                msg = $filter('translate')('agreed on the latest approved timecard');
                                break;

                            case 'EMPLOYER_APPROVED':
                                msg = $filter('translate')('changed employee acknowledgement from') + ' -- ' + $filter('translate')('to confirmed by employer');
                                break;

                            case 'PENDING_EMPLOYEE_APPROVAL':
                                msg = $filter('translate')('set employee acknowledgement to pending');
                                break;

                            case 'EMPLOYEE_ACKNOWLEDGED':
                                msg = $filter('translate')('acknowledged the latest approved timecard');
                                break;
                        }
                    } else if (entry.action === 'UPDATE') {
                        switch (from) {
                            case 'PENDING_EMPLOYEE_APPROVAL':
                                switch (to) {
                                    case 'EMPLOYEE_PROTESTED':
                                        msg = $filter('translate')('disagreed on the latest approved timecard');
                                        break;

                                    case 'EMPLOYEE_APPROVED':
                                        msg = $filter('translate')('agreed on the latest approved timecard');
                                        break;

                                    case 'EMPLOYER_APPROVED':
                                        msg = $filter('translate')('changed employee acknowledgement from pending to confirmed by employer');
                                        break;

                                    case 'EMPLOYEE_ACKNOWLEDGED':
                                        msg = $filter('translate')('acknowledged the latest approved timecard');
                                        break;
                                }
                                break;

                            case 'EMPLOYEE_PROTESTED':
                                switch (to) {
                                    case 'PENDING_EMPLOYEE_APPROVAL':
                                        msg = $filter('translate')('changed employee acknowledgement from protested to pending');
                                        break;

                                    case 'EMPLOYEE_APPROVED':
                                        msg = $filter('translate')('agreed on the latest approved timecard');
                                        break;

                                    case 'EMPLOYER_APPROVED':
                                        msg = $filter('translate')('changed employee acknowledgement from protested to confirmed by employer');
                                        break;
                                }
                                break;

                            case 'EMPLOYEE_APPROVED':
                                switch (to) {
                                    case 'PENDING_EMPLOYEE_APPROVAL':
                                        msg = $filter('translate')('changed employee acknowledgement from confirmed to pending');
                                        break;

                                    case 'EMPLOYEE_PROTESTED':
                                        msg = $filter('translate')('disagreed on the latest approved timecard');
                                        break;

                                    case 'EMPLOYER_APPROVED':
                                        msg = $filter('translate')('changed employee acknowledgement from confirmed to confirmed by employer');
                                        break;
                                }
                                break;

                            case 'EMPLOYER_APPROVED':
                                switch (to) {
                                    case 'PENDING_EMPLOYEE_APPROVAL':
                                        msg = $filter('translate')('changed employee acknowledgement from confirmed by employer to pending');
                                        break;

                                    case 'EMPLOYEE_PROTESTED':
                                        msg = $filter('translate')('disagreed on the latest approved timecard');
                                        break;

                                    case 'EMPLOYEE_APPROVED':
                                        msg = $filter('translate')('agreed on the latest approved timecard');
                                        break;
                                }
                                break;

                            case 'EMPLOYEE_ACKNOWLEDGED':
                                switch (to) {
                                    case 'PENDING_EMPLOYEE_APPROVAL':
                                        msg = $filter('translate')('changed employee acknowledgement from acknowledged by employee to pending');
                                        break;
                                }
                                break;
                        }
                    }

                    break;

                case 'actual_clock.job_titles':
                    if (entry.action === 'ADD') {
                        msg = `${$filter('translate')("Added")} ${jobTitleItem.name} ${$filter('translate')("station started from")} ${$filter("formatDateIgnoreTimeZone")(entry.meta.start_time, "hh:mm A")} ${$filter('translate')("to")} ${$filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A")}`
                        break;
                    } else if (entry.action === 'DELETE') {
                        msg = `${$filter('translate')("Removed the")} ${jobTitleItem.name} ${$filter('translate')("station")} ${$filter("formatDateIgnoreTimeZone")(entry.meta.start_time, "hh:mm A")} - ${$filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A")}`
                        break;
                    }

                case 'actual_clock.job_titles.start_time':
                    if (entry.action === 'UPDATE') {
                        msg = `${$filter('translate')("Modified the")} ${jobTitleItem.name} ${$filter('translate')("station")} ${$filter("formatDateIgnoreTimeZone")(entry.from, "hh:mm A")} - ${$filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A")} ${$filter('translate')("to")} ${jobTitleItem.name} ${$filter("formatDateIgnoreTimeZone")(entry.to, "hh:mm A")} - ${$filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A")}`
                    }
                    break;
                case 'actual_clock.job_titles.end_time':
                    if (entry.action === 'UPDATE') {
                        msg = `${$filter('translate')("Modified the")} ${jobTitleItem.name} ${$filter('translate')("station")} ${$filter("formatDateIgnoreTimeZone")(entry.meta.start_time, "hh:mm A")} - ${$filter("formatDateIgnoreTimeZone")(entry.from, "hh:mm A")} ${$filter('translate')("to")} ${jobTitleItem.name} ${$filter("formatDateIgnoreTimeZone")(entry.meta.start_time, "hh:mm A")} - ${$filter("formatDateIgnoreTimeZone")(entry.to, "hh:mm A")}`
                    }
                    break;

                case 'actual_clock.overtime.is_weekly_entitled':
                    if (entry.from) {
                        msg = $filter('translate')('Turned the overtime OFF');
                        break;
                    } else if (!entry.to) {
                        msg = $filter('translate')('Turned the overtime OFF');
                        break;
                    } else {
                        msg = $filter('translate')('Turned the overtime ON');
                        break;
                    }

                case 'edit_card_reason':
                    msg = $filter('translate')('reason for change:') + ' ' + entry.to;
                    break;

                default:
                    if (activeBrand.tronc && activeBrand.tronc.sources && entry.attribute) {
                        var getTroncSourcesMessages = function (sourceName) {
                            if (entry.type === 'DISTRIBUTION') {
                                switch (entry.action) {
                                    case "ADD":
                                        return $filter("translate")('distributed') + " " + sourceName + " " + $filter("translate")("from") + " " + currency + "0 " + $filter("translate")('to') + currency + (parseFloat(entry.to / 100).toFixed(2));

                                    case "DELETE":
                                        return $filter("translate")('deleted distributed') + " " + sourceName;

                                    case "UPDATE":
                                        return $filter("translate")('distributed') + " " + sourceName + " " + $filter("translate")('from') + " " + currency + parseFloat(entry.from / 100).toFixed(2) + " " + $filter("translate")('to') + " " + currency + parseFloat(entry.to / 100).toFixed(2);
                                }
                            } else {
                                switch (entry.action) {
                                    case "ADD":
                                        return $filter("translate")('modified') + " " + sourceName + " " + $filter("translate")('amount from') + currency + "0" + $filter("translate")('to') + " " + currency + parseFloat(entry.to / 100).toFixed(2);

                                    case "UPDATE":
                                        return $filter("translate")('modified') + " " + sourceName +  " " + $filter("translate")('amount from') + " " + currency + parseFloat(entry.from / 100).toFixed(2) + " " + $filter("translate")('to') + " " + currency + parseFloat(entry.to / 100).toFixed(2);
                                }
                            }
                        };

                        var sources = activeBrand.tronc.sources;

                        for (var i in sources) {
                            var source = sources[i];
                            var sourceCode = source.code || "";
                            var generatedAttribute = "actual_clock.tronc_" + sourceCode.toLowerCase();

                            if (entry.attribute.indexOf(generatedAttribute) === 0) {
                                var dayChangedText;

                                if (entry.attribute.indexOf('business_day_part_1') > -1) {
                                    dayChangedText = 'for hours worked on first business day';
                                }

                                if (entry.attribute.indexOf('business_day_part_2') > -1) {
                                    dayChangedText = 'for hours worked on Second business day';
                                }

                                msg = getTroncSourcesMessages(source.name);

                                if (dayChangedText) {
                                    msg += ' ' + $filter("translate")(dayChangedText);
                                }
                                break;
                            }
                        }
                    }
            }

            defer.resolve(msg || "");
            return defer.promise;
        };

        CTTimesheetService.getBrandShiftTemplates = function () {
            var defer = $q.defer();

            TLEmployerSettingsDataService
                .getBrandShiftTemplates()
                .then(function (shiftTemplates) {
                    var templates = shiftTemplates || [];
                    CTTimesheetService.shiftTemplates = {};

                    for (var i in templates) {
                        var template = templates[i];

                        CTTimesheetService.shiftTemplates[template.code] = template;
                    }

                    defer.resolve(CTTimesheetService.shiftTemplates);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        const getAutoResolvedBreakMsg = (entry) => {
            const breakDuration = getBreakDuration(entry);
            const breakCategory = entry.meta?.category ? getBreakCategory(entry.meta.category) : '';
            let action = '';

            if (
                [
                    BREAK_STATUSES.AUTOMATIC_ADD_TO_PAID_TIME,
                    BREAK_STATUSES.CONSUMED
                ].includes(entry.meta.status)
            ) {
                action = $filter("translate")("added");
            }
            else if (entry.meta.status === BREAK_STATUSES.AUTOMATICALLY_IGNORED) {
                action = $filter("translate")("dismissed");
            }
            let msg = [
                $filter("translate")("Automatically"),
                action,
                $filter("translate")("a"),
                breakDuration,
                $filter("translate")("minutes"),
                breakCategory,
                $filter("translate")("break"),
            ].join(" ");

            if (entry.meta.start_time && entry.meta.end_time) {
                msg += " " + $filter("translate")("from") + " " + $filter("formatDateIgnoreTimeZone")(entry.meta.start_time, "hh:mm A")
                    + " " + $filter("translate")("to") + " " + $filter("formatDateIgnoreTimeZone")(entry.meta.end_time, "hh:mm A");
            }

            if (entry.meta.status === 'AUTOMATIC_ADD_TO_PAID_TIME') {
                msg += ' ' + 'to pay time'
            }

            return msg;
        }

        CTTimesheetService.isDistributionSectionShown = false;
        CTTimesheetService.setDistributionSectionShown = (isShown) => {
            CTTimesheetService.isDistributionSectionShown = isShown;
        };

        CTTimesheetService.getEditTimeCardReasons = function () {
            var defer = $q.defer();

            PerformanceAggregatorAPI
                .getEditTimeCardReasons(activeBrand.id)
                .then(function (res) {
                    CTTimesheetService.setEditTimeCardReasons(res['clock_edit_reasons'] || []);
                    defer.resolve(res);
                }, function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        };

        CTTimesheetService.updateEmployerTimeSheetSettings = function (settings) {
            missedBreakAction = settings.breaks.missed_break_action

            isSickLeaveEnabled = settings.sick_leave.enable_sick_leave;
            CTTimesheetService.shiftBasedScheduling = settings.schedule_shift_mode === "TEMPLATE";

            CTTimesheetService.setSickLeaveEnabled(settings.sick_leave.enable_sick_leave);
            CTTimesheetService.setBlockOverlappingTimeCardsEnabled(settings['block_overlapping_timecard']);
            CTTimesheetService.updateEmployerTimesheetTipsSettings(settings['tip_declaration']);
            CTTimesheetService.updateCallInSettings(settings['call_ins']);
            CTTimesheetService.updateBreaksSettings(settings['breaks']);
            CTTimesheetService.updateBreakEnginesSettings(settings['break_engines']);
            CTTimesheetService.updateSplitShiftPenaltySettings(settings['split_shift_penalty']);
            CTTimesheetService.setBreakWaiverOnFileSettings(settings['break_waiver_files'] || []);
            CTTimesheetService.updateClockTimeStatusReasonSettings(settings['clock_time_status_reason_settings']);
            CTTimesheetService.updateAttestationFlowSettings(settings['clock_time_status_reason_tracking_settings']);
            CTTimesheetService.setTimeSheetAdjusmentsSettings(settings['timesheet_adjusments'] || {});
            CTTimesheetService.setTimeSheetOfflineConflictsSettings(settings['offline_mode'] || {});
            CTTimesheetService.updateBreakPenaltiesSettings(settings['break_penalties']);
            CTTimesheetService.updateOvernightShiftSettings(settings['overnight_shift']);
            CTTimesheetService.updateEmployeeConsentFlowSetting(settings['employee_consent_flow_enabled']);
        };

        CTTimesheetService.getBreaksPaymentSettings = function (date) {
            var paymentBreakSetting = CTTimesheetService.breaksSettings['payment_settings'] || {};
            var breakPaymentDetails = {paid_break_payment: {}, unpaid_break_payment: {}};

            for (var j in paymentBreakSetting['paid_breaks']) {
                var paidBreakSetting = paymentBreakSetting['paid_breaks'][j];
                if (new Date(date).getTime() >= new Date(paidBreakSetting.start_date).getTime()) {
                    breakPaymentDetails['paid_break_payment'] = {threshold: paidBreakSetting['threshold']};
                    break;
                }
            }

            for (var k in paymentBreakSetting['unpaid_breaks']) {
                var paidBreakSetting = paymentBreakSetting['unpaid_breaks'][k];
                if (new Date(date).getTime() >= new Date(paidBreakSetting.start_date).getTime()) {
                    breakPaymentDetails['unpaid_break_payment'] = {threshold: paidBreakSetting['threshold']};
                    break;
                }
            }
            return breakPaymentDetails;
        };

        CTTimesheetService.getTimeCardAttemptActionText = function (attempt, positionName) {

            let attemptText;

            switch (attempt.action) {
                case "SCHEDULED_CLOCK_IN":
                    attemptText = {
                        action: $filter('translate')("Clocked in"),
                        title: $filter('translate')("Clock in")
                    };
                    break;

                case "EARLY_CLOCK_IN":
                    attemptText = {
                        action: $filter('translate')("Clocked in early"),
                        title: $filter('translate')("Clock in early")
                    };
                    break;

                case "EARLY_CLOCK_OUT":
                    attemptText = {
                        action: $filter('translate')("Clocked out early"),
                        title: $filter('translate')("Clock out early")
                    };
                    break;

                case "UNSCHEDULED_CLOCK_IN":
                    attemptText = {
                        action: `${$filter('translate')("Started an unscheduled")} ${positionName} ${$filter('translate')("shift")}`,
                        title: `${$filter('translate')("Start an unscheduled")} ${positionName} ${$filter('translate')("shift")}`,
                    };
                    break;

                case "SCHEDULED_CLOCK_OUT":
                    attemptText = {
                        action: $filter('translate')("Clocked out"),
                        title: $filter('translate')("Clock out")
                    };
                    break;

                case "UNSCHEDULED_CLOCK_OUT":
                    attemptText = {
                        action: `${$filter('translate')("Ended an unscheduled")} ${positionName} ${$filter('translate')("shift")}`,
                        title: `${$filter('translate')("End an unscheduled")} ${positionName} ${$filter('translate')("shift")}`,
                    };
                    break;

                case "BREAK_IN":
                    attemptText = {
                        action: $filter('translate')("Started Break"),
                        title: $filter('translate')("Start Break"),
                    };
                    break;

                case "BREAK_OUT":
                    attemptText = {
                        action: $filter('translate')("Ended Break"),
                        title: $filter('translate')("End Break"),
                    };
                    break;

                case "LATE_CLOCK_IN":
                    attemptText = {
                        action: $filter('translate')("Clocked in late"),
                        title: $filter('translate')("Clock in late"),
                    };
                    break;

                case "LATE_CLOCK_OUT":
                    attemptText = {
                        action: $filter('translate')("Clocked out late"),
                        title: $filter('translate')("Clock out late"),
                    };
                    break;

                case "LATE_BREAK_IN":
                    attemptText = {
                        action: $filter('translate')("Late Break in"),
                        title: $filter('translate')("Late Break in"),
                    };
                    break;

                case "EARLY_BREAK_IN":
                    attemptText = {
                        action: $filter('translate')("Early Break in"),
                        title: $filter('translate')("Early Break in"),
                    };
                    break;

                case "EARLY_BREAK_OUT":
                    attemptText = {
                        action: $filter('translate')("Early Break out"),
                        title: $filter('translate')("Early Break out"),
                    };
                    break;

                case "LATE_BREAK_OUT":
                    attemptText = {
                        action: $filter('translate')("Late Break out"),
                        title: $filter('translate')("Late Break out"),
                    };
                    break;

                case "EARLY_CLOCK_IN_ADMIN_APPROVAL":
                    attemptText = {
                        action: `${$filter('translate')("Manager Approval for")}: ${$filter('translate')("Early Clock in")}`,
                    };
                    break;

                case "EARLY_CLOCK_OUT_ADMIN_APPROVAL":
                    attemptText = {
                        action: `${$filter('translate')("Manager Approval for")}: ${$filter('translate')("Early Clock out")}`,
                    };
                    break;

                case "LATE_CLOCK_IN_ADMIN_APPROVAL":
                    attemptText = {
                        action: `${$filter('translate')("Manager Approval for")}: ${$filter('translate')("Late Clock in")}`,
                    };
                    break;

                case "LATE_CLOCK_OUT_ADMIN_APPROVAL":
                    attemptText = {
                        action: `${$filter('translate')("Manager Approval for")}: ${$filter('translate')("Late Clock out")}`,
                    };
                    break;

                case "UNSCHEDULED_CLOCK_IN_ADMIN_APPROVAL":
                    attemptText = {
                        action: `${$filter('translate')("Manager Approval for")}: ${$filter('translate')("Starting an unscheduled shift")}`,
                    };
                    break;

                case "UNSCHEDULED_CLOCK_OUT_ADMIN_APPROVAL":
                    attemptText = {
                        action: `${$filter('translate')("Manager Approval for")}: ${$filter('translate')("Ending an unscheduled shift")}`,
                    };
                    break;

                case "SCHEDULED_CLOCK_IN_ADMIN_APPROVAL":
                    attemptText = {
                        action: `${$filter('translate')("Manager Approval for")}: ${$filter('translate')("Scheduled Clock in")}`,
                    };
                    break;

                case "SCHEDULED_CLOCK_OUT_ADMIN_APPROVAL":
                    attemptText = {
                        action: `${$filter('translate')("Manager Approval for")}: ${$filter('translate')("Scheduled Clock out")}`,
                    };
                    break;

                case "EARLY_BREAK_IN_ADMIN_APPROVAL":
                    attemptText = {
                        action: `${$filter('translate')("Manager Approval for")}: ${$filter('translate')("Early Break in")}`,
                    };
                    break;

                case "LATE_BREAK_IN_ADMIN_APPROVAL":
                    attemptText = {
                        action: `${$filter('translate')("Manager Approval for")}: ${$filter('translate')("Late Break in")}`,
                    };
                    break;

                case "EARLY_BREAK_OUT_ADMIN_APPROVAL":
                    attemptText = {
                        action: `${$filter('translate')("Manager Approval for")}: ${$filter('translate')("Early Break out")}`,
                    };
                    break;

                case "LATE_BREAK_OUT_ADMIN_APPROVAL":
                    attemptText = {
                        action: `${$filter('translate')("Manager Approval for")}: ${$filter('translate')("Late Break out")}`,
                    };
                    break;

                case "BREAK_OUT_ADMIN_APPROVAL":
                    attemptText = {
                        action: `${$filter('translate')("Manager Approval for")}: ${$filter('translate')("Break out")}`,
                    };
                    break;

                case "BREAK_IN_ADMIN_APPROVAL":
                    attemptText = {
                        action: `${$filter('translate')("Manager Approval for")}: ${$filter('translate')("Break in")}`,
                    };
                    break;

                case "EARLY_CLOCK_IN_ATTEMPT":
                    attemptText = {
                        action: $filter('translate')("Employee attempt to clock in early"),
                    };
                    break;

                case "EARLY_CLOCK_OUT_ATTEMPT":
                    attemptText = {
                        action: $filter('translate')("Employee attempt to clock out early"),
                    };
                    break;

                case "LATE_CLOCK_IN_ATTEMPT":
                    attemptText = {
                        action: $filter('translate')("Employee attempt to clock in late"),
                    };
                    break;

                case "LATE_CLOCK_OUT_ATTEMPT":
                    attemptText = {
                        action: $filter('translate')("Employee attempt to clock out late"),
                    };
                    break;

                case "EARLY_BREAK_IN_ATTEMPT":
                    attemptText = {
                        action: $filter('translate')("Employee attempt to break in early"),
                    };
                    break;

                case "EARLY_BREAK_OUT_ATTEMPT":
                    attemptText = {
                        action: $filter('translate')("Employee attempt to break out early"),
                    };
                    break;

                case "BREAK_IN_ATTEMPT":
                    attemptText = {
                        action: $filter('translate')("Employee attempt to break in"),
                    };
                    break;

                case "BREAK_OUT_ATTEMPT":
                    attemptText = {
                        action: $filter('translate')("Employee attempt to break out"),
                    };
                    break;

                case "LATE_BREAK_IN_ATTEMPT":
                    attemptText = {
                        action: $filter('translate')("Employee attempt to break in late"),
                    };
                    break;

                case "LATE_BREAK_OUT_ATTEMPT":
                    attemptText = {
                        action: $filter('translate')("Employee attempt to break out late"),
                    };
                    break;

                case "SCHEDULED_CLOCK_IN_ATTEMPT":
                    attemptText = {
                        action: $filter('translate')("Employee attempt to start a scheduled shift"),
                    };
                    break;

                case "SCHEDULED_CLOCK_OUT_ATTEMPT":
                    attemptText = {
                        action: $filter('translate')("Employee attempt to end a scheduled shift"),
                    };
                    break;

                case "UNSCHEDULED_CLOCK_IN_ATTEMPT":
                    attemptText = {
                        action: $filter('translate')("Employee attempt to start an unscheduled shift"),
                    };
                    break;

                case "UNSCHEDULED_CLOCK_OUT_ATTEMPT":
                    attemptText = {
                        action: $filter('translate')("Employee attempt to end an unscheduled shift"),
                    };
                    break;

                case "NO_ACTION":
                    const noActionText = $filter('translate')("No action");
                    if (attempt.isBlockerConfirmation) {
                        attemptText = {
                            action: `${$filter('translate')("Manager Approval for")}: ${noActionText}`,
                        };
                    } else {
                        attemptText = {
                            action: noActionText,
                            title: noActionText,
                        };
                    }
                    break;
            }

            if (attempt.isBlockerConfirmation && !attempt.showUnsuccessfulConfirmationMessage) {
                const confirmationText = ` (${ $filter('translate')("Login Confirmation") })`;
                attemptText.action += confirmationText;
                attemptText.title += confirmationText;
            }

            return attemptText;
        };

        CTTimesheetService.getConfidenceTypeAttempts = function (selectedDate) {
            var defer = $q.defer();

            var promises = {
                'brand': TeamScheduleService.getActiveBrand(),
                'clockLoginSettings': TimesheetSettingsService.getClockLoginSettings()
            };

            $q.all(promises)
                .then(function (result) {
                    var activeBrand = result['brand'];
                    var loginSettings = result['clockLoginSettings'];

                    if (loginSettings['enable_recognition_warnings'] && isPunchPhotosAllowed) {
                        RecognitionAPI.getConfidenceTypeAttempts(activeBrand.id, selectedDate)
                            .then(function (confidenceTypeAttempts) {
                                defer.resolve(confidenceTypeAttempts['days']);
                            })
                    } else {
                        defer.resolve([]);
                    }
                })
                .catch(function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        CTTimesheetService.getEmployerTimesheetSettings = function () {
            var defer = $q.defer();

            TimesheetSettingsService.loadTimesheetSettings()
                .then(function (settings) {
                    CTTimesheetService.updateEmployerTimeSheetSettings(settings);
                    defer.resolve(settings);
                })
                .catch(function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };


        CTTimesheetService.getTimeSheetConflicts = function (date, mode) {
            var defer = $q.defer();

            TimesheetSettingsService.isOfflineModeEnabled()
                .then(function (isOfflineModeEnabled) {
                    if (isOfflineModeEnabled) {
                        PerformanceAggregatorAPI
                            .getTimeSheetConflicts(activeBrand.id, date, mode)
                            .then(function (res) {
                                defer.resolve(res);
                            }, function (err) {
                                defer.reject(err);
                            });
                    } else {
                        defer.resolve([]);
                    }
                });

            return defer.promise;
        };

        CTTimesheetService.getTimesheetOfflineConflictsIntervals = function (brandId, params) {
            var defer = $q.defer();

            TimesheetSettingsService.isOfflineModeEnabled()
                .then(function (isOfflineModeEnabled) {
                    if (isOfflineModeEnabled) {
                        PerformanceAggregatorAPI
                            .getTimesheetOfflineConflictsIntervals(brandId, params)
                            .then(function (res) {
                                defer.resolve(res);
                            })
                            .catch(function (err) {
                                defer.reject(err);
                            });
                    } else {
                        defer.resolve([]);
                    }
                });

            return defer.promise;
        };

        CTTimesheetService.getEmployeeClockConsentDetails = function (brandId, clockId, shiftId, isScheduled) {
            var deferred = $q.defer();
            var methods = {};

            if (isScheduled) {
                methods['cross_schedule_consents'] = TeamScheduleAPI.getEmployeeClockCrossConsentDetails(brandId, shiftId, {statuses: 'APPROVED', premium_types: 'RIGHT_TO_REST'});
                methods['scheduled'] = TeamScheduleAPI.getEmployeeClockConsentDetails(brandId, shiftId, {statuses: 'APPROVED', premium_types: 'DATE_TIME_CHANGE,LENGTH_DECREMENT,LENGTH_INCREMENT'});
            }

            methods['unscheduled'] = PerformanceAggregatorAPI.getEmployeeClockConsentDetails(brandId, clockId);


            $q.all(methods)
                .then(function (response) {
                    var scheduled = response.scheduled || [];
                    var unscheduled = response.unscheduled || [];
                    var crossScheduleConsents = response.cross_schedule_consents || [];

                    unscheduled.forEach(function (consent) {
                        consent.isUnscheduled = true;
                    })
                    var consentsList = unscheduled.concat(scheduled).concat(crossScheduleConsents);
                    deferred.resolve(consentsList);
                })
                .catch(function (error) {
                    console.error(error);
                    deferred.resolve([]);
                });

            return deferred.promise;
        };

        CTTimesheetService.getEmployeeLatenessReasons = function (brandId) {
            var deferred = $q.defer();

            if (brandEmployeeLatenessReasons[brandId]) {
                deferred.resolve(brandEmployeeLatenessReasons[brandId]);
            } else {
                TeamScheduleAPI.getLatenessReasons(brandId)
                    .then(function (response) {
                        var reasons = response.reduce(function (reasonsMap, reason) {
                            reasonsMap[reason.id] = reason.name;
                            return reasonsMap;
                        }, {});
                        brandEmployeeLatenessReasons[brandId] = reasons;
                        deferred.resolve(reasons);
                    })
                    .catch(function (error) {
                        console.error(error);
                        deferred.resolve({});
                    });
            }
            return deferred.promise;
        }

        return CTTimesheetService;
    }]);

})(angular.module('harriApp'));
